import Hdr from '../shared/Hdr'
import React, { useActionState } from 'react'
import swal from 'sweetalert';
import { useState, useEffect } from 'react';
import { apiPath1 } from "../services/apiConfig";
//import { Link } from 'react-router-dom';
import TopBanner from '../components/TopBanner';
import LoadingModal from '../components/Loading';
//import { useReactToPrint } from 'react-to-print';
import Invoice from '../components/Invoice';
import { motion, AnimatePresence } from "framer-motion";
import Swal from 'sweetalert2';

import myImage from '../asset/icons/inventory.png';
import { alertTitleClasses } from '@mui/material';

function Transaction() {

  //const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  //const usrRole = localStorage.getItem('user-role');
  //const user_id = localStorage.getItem('user-id');
  //const usrName = localStorage.getItem('userName');
  //const [department_name, setDepartment] = useState("");
  //const [section_name, setSecName] = useState("");
  //const [toolName, setToolName] = useState("");
  //const [secName, setSectionName] = useState("");
  //const [display, setDisplay] = useState('none');
  
  const [display, setDisplay] = useState(false);
  const [displayIssue, setDisplayIssue] = useState(false);

  const [displayReceipt, setDisplayReceipt] = useState(false)
  const [displayTransfer, setDisplayTransfer] = useState(false)
  const [displayReturn, setDisplayReturn] = useState(false)
  const [displayUpdate, setDisplayUpdate] = useState(false);
  const [displayView, setDisplayView] = useState(false);
  const [displayReceiptReceipt, setDisplayReceiptReceipt] = useState(false)
  const [displayPurchase, setDisplayPurchase] = useState(false)
  const [displayRepair, setDisplayRepair] = useState(false)
  const [displayRepairReceipt, setDisplayRepairReceipt] = useState(false)

  const [displayTransfer_old,setDisplaTransferOld] = useState(false)
  const [displayStorePop, setdisplayStorePop] = useState(false)


 // const [displayUpdateTrDet, setDisplayUpdateTrDet] = useState('none');
  const [displayTransitButton, setDisplayTransitButton] = useState('block')
  const [data, setData] = useState([]);
 // const [section, setSection] = useState([]);
  const [trID, setTrID] = useState('')
 // const [secID, setSecID] = useState('')
 // const [secStat, setSecStat] = useState()

  const [categoryData, setCategoryData] = useState([])
  const [uom, setUOM] = useState()
  const [purdate, setPurDate] = useState([])
  const [repdate, setRepDate] = useState([])
  const [cpu, setCPU] = useState()
  const [qty, setQTY] = useState()
  const [status, setStatus] = useState()
  const [category, setCategory] = useState()
  const [toolcode, setToolCode] = useState()
  const [description, setDescription] = useState()

  const [updToolName, setUpdToolName] = useState()
  const [updToolCode, setUpdToolCode] = useState()
  const [upddescription, setupdDescription] = useState()
  const [updcategoryID, setupdCategoryId] = useState()
  const [updUom, setupdUOM] = useState()
  const [updCPU, setupdCPU] = useState()
  const [updDop, setupdDOP] = useState()
  const [updQty, setupdQty] = useState()

  const [updDor, setupdDOR] = useState()
  const [updToolId, setupdToolID] = useState()
  const [updToolType, setupdToolType] = useState()
  const [tooltype, setToolType] = useState()

  const [storedata, setStores] = useState([])
  const [siteStoredata, setSiteStores] = useState([])
  const [deptSiteStoredata, setDeptSiteStores] = useState([])
  const [warehouseStoredata, setWarehouseStores] = useState([])
  const [tools, setTools] = useState([])
  const [trno, setIndetNO] = useState()
  const [trdt, setIndetDt] = useState()
  const [storeId, setStoreId] = useState()
  const [warehouseId, setWarehouseId] = useState()
  const [remarks, setRemarks] = useState()
  const [storeName, setStoreName] = useState()
  const [trdetail, setTrDet] = useState([])
  const [updTrId, setupdTrID] = useState()
  const [selectedUom, setSelectedUom] = useState()
  const [selectedToolCode, setSelectedToolCode] = useState()

  const [updQuantity, setupdQuantity] = useState()


  const [displayTrDet, setDisplayTrDet] = useState('none')
  const [selectType, setSelectType] = useState("0")

  const [inventoryDataStatus, setInventoryDataStatus] = useState([])
  const [inventoryData, setInventoryData] = useState([])
  // const [dor,setDor]= useState()


  const [updTrNo, setUpdTrNo] = useState()
  const [updTrDt, setUpdTrDt] = useState()
  const [updDocRef, setUpdDocRef] = useState()
  const [updStoreId, setupdStoreId] = useState()
  const [updStoreName, setupdStoreName] = useState()
  //const [updTrType, setUpdTrType] = useState()
  const [updStatus, setUpdStatus] = useState()

  const [tQty, setTQTY] = useState()

  const [trDetStat, setTrDetStat] = useState(false)
  const [trDocId, setTrDocId] = useState()
  const [inactiveCatelog, setInactiveCatelog] = useState(false)

  const [indentAvl, setIndentAvl] = useState(false)

  const [categoryId, setCategoryId] = useState()

  const [btnTxt, setBtnTxt] = useState('Add Transaction')
  //const [transHeading,setTransHeading]=useState()
  const [trType, setTrType] = useState("0")
  const [trTypeName, setTrTypeName] = useState('')
  const [trDt, setTrDt] = useState()
  const [trRef, setTrRef] = useState("0")
  const [trStore, setTrStore] = useState()
  const [trStatus, setTrStatus] = useState('Pending')
  const [trNo, setTrNo] = useState()
  //const [trID,setTrID] = useState()

  const [itemDetails, setItemDetails] = useState([])
  const [issueItems, setIssueItems] = useState([])

  const [refData, setRefData] = useState([])
  //const [refStat, setRefStat] = useState()

  const [issuedItems, setIssuedItems] = useState([])
  const [issuedItemStatus, setIssuedItemStatus] = useState(false)

  const [quantities, setQuantities] = useState(itemDetails.map(() => ''));
  const [rcvdQty, setRcvdQty] = useState(issuedItems.map(() => 0));

  const [savedData, setSavedData] = useState([]);
  const [savedData2, setSavedData2] = useState([]);

  const [updIssueNo, setUpdIssueNo] = useState()
  const [updIssueDt, setUpdIssueDt] = useState()
  const [updIssueStatus, setUpdIssueStatus] = useState()
  const [updIssueStoreId, setUpdIssueStoreId] = useState()

  const [viewData, setViewData] = useState([])
  const [viewDataStatus, setViewDataStatus] = useState(false)

  const [updItemId, setUpdItemId] = useState()
  const [displayUpdateIssueDet, setDisplayUpdateIssueDet] = useState(false)

  const [deleteTrFlag, setDeleteTrFlag] = useState(true)
  const [modifyTrFlag, setModifyTrFlag] = useState(true)

  const [rtndQty, setRtndQty] = useState([])
  const [returnedItem, setReturnedItem] = useState([])
  const [returnedItemStatus, setReturnedItemStatus] = useState()

  const [repdItems, setRepdItems] = useState([])
  const [repdItemStatus, setRepdItemStatus] = useState()

  const [rcvdRetQty, setRcvdRetQty] = useState(returnedItem.map(() => ''));
  const [repdQty, setRepdQty] = useState([])
  const [repdRetQty, setRepdRetQty] = useState(repdItems.map(() => ''));

  //const [returnedItems, setReturnedItems] = useState([])
  const [retItemStatus, setRetItemStatus] = useState(false)
  const [retItems, setRetItems] = useState([])

  const [lineitem, setLineItem] = useState([])
  const [lineitemStatus, setLineItemStatus] = useState(false)

  const [repairLineitem, setRepairLineItem] = useState([])
  const [repairLineitemStatus, setRepairLineItemStatus] = useState(false)

  const [poNumber, setPONumber] = useState()

  const [selectedToolName, setSelectedToolName] = useState()
  const [selectedToolID, setSelectedToolID] = useState()

  const [cost, setCost] = useState()
  const [itemReady, setItemReady] = useState(false)
  const [items, setItems] = useState([])

  const [repairShops, setRepairShops] = useState([])
  const [toolsDamaged, setToolsDamaged] = useState([])

  const [reciptRef, setReceiptRef] = useState()
  const [indRef, setIndref] = useState()
  const [trRefDoc, setTrRefDoc] = useState()
  const [issuedItemsList, setIssuedItemsList] = useState([])
  const [issuedItemListStatus, setIssuedItemListStatus] = useState(false)
  const [returnedItemListStatus, setReturnedItemListStatus] = useState(false)
  const [returnedItemsList, setReturnedItemsList] = useState([])
  const [refIndentData, setRefIndentData] = useState([])
  const [refStatus, setRefStatus] = useState()
  const [pendItemStatus, setPendingItemStatus] = useState(false)
  const [pendingRepairedItems, setPendingRepairedItems] = useState([])
  const [repairedItems, setRepairedItems] = useState([])
  const [repairedItemStatus, setRepairedItemStatus] = useState(false)
  const [loading, setLoading] = useState(false);

  const [selectedStoreValue, setSelectedStoreValue] = useState('0')
  
  const [selectedRefValue, setSelectedRefValue] = useState('0')
  const [selectedRefIndent, setSelectedRefIndent] = useState('0')

  const [selectedDate, setSelectedDate] = useState('');
  const [selectedIndent, setSelectedIndent] = useState('0')
  const [selectedIssuedItem, setSelectedIssuedItem] = useState('0')
  const [selectedWarehouseStoreValue, setSelectedWarehouseStoreValue] = useState('0')
  const [selectedReturnedRef, setSelectedReturnedRef] = useState('0')
  const [selectedRepairShop, setSelectedRepairShop] = useState('0')
  const [selecteRepairdItem, setSelecteRepairdItem] = useState('0')

  const [printId, setPrintId] = useState(0)

  const [printFlag, setPrintFlag] = useState(false)

  const [invoiceData2, setInvoiceData2] = useState({})
  const [invoiceStatus, setInvoiceStatus] = useState(false)

  const [storesByDept,setStoresByDept] = useState([])

  const [lineIndentitem, setLineIndentItem] = useState([])
  const [categoryForPurchaseData,setCategoryForPurchaseData] = useState([])


  function MyPrintableComponent(){

    getInvoice(printId)
    if (invoiceStatus === true){
      setPrintFlag(true)
    }
  }  
 
  useEffect(() => {

    getTransactions()
    getToolCategory()
    getToolCategoryByUser()
    getStores()
    getWarehouseStores()
    getSiteStores()
    getRepairShops()
    //  getDamageTools()

    clearLineItems()

  }, [])

  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };

  /*DELETE TRANSACTION */

  function deleteOperation(id) {

    return

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          //  DeleteTr(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }



  /* FIND CATAGORY RECORD ON THE BASIS OF CATAGORY ID*/

  function updateOperation(id) {

  //  alert('update '+id)

    if (trType === '0') {
      swal('To Update, select Transaction Type')
      return 
    }


    if (trType === 'O') { 
      swal('Choose Inventory Module to update Opening Entry ')
      return 
    }

    if(trTypeName === 'Issue'){
      getIssueUpdateData(id)
    }else if(trTypeName === 'Transfer'){
      getIssueUpdateData(id)
    }else{
//      getIssueUpdateData(id)
      getUpdateData(id)
    }
   
  }

  async function getUpdateData(id){

    let result = await fetch(apiPath1 + "ToolTransaction/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setViewDataStatus(result.status)

    if (result.status === true) {
      // alert('true')
      setViewData(result.data)
      getInventoryByStoreId(result.data.tool_transaction[0].store_id)
      setupdStoreId(result.data.tool_transaction[0].store_id)
    } else {
      setViewData([])
      return
    }

    setTrType(result.data.transaction_type)
    setTypeName(result.data.transaction_type)
    setupdTrID(id)

    openUpdate()

    //getTransactionsByType

  }

  async function getIssueUpdateData(id){

   // alert('getIssueUpdateData'+id)

    let result = await fetch(apiPath1 + "ToolIssueTransfer/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setViewDataStatus(result.status)

    if (result.status === true) {
      // alert('true')
      setViewData(result.data)
      getInventoryByStoreId(result.data.tool_transaction[0].store_id)
      setupdStoreId(result.data.tool_transaction[0].store_id)
    } else {
      setViewData([])
      return
    }

    setTrType(result.data.transaction_type)
    setTypeName(result.data.transaction_type)
    setupdTrID(id)

    openUpdate()

    //getTransactionsByType

  }

  async function View(id) {

   // alert('view '+ id)

    if (trTypeName === '') {
       swal('To View Document Select Transaction Type')
       return 
    }
/*
    if (trTypeName === 'Opening') { 
      swal('Check Inventory Details')
      return 
    }
*/
    setPrintId(id)


    if(trTypeName === 'Issue'){
      let result = await fetch(apiPath1 + "ToolIssueTransfer/" + id,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
  
      result = await result.json();
      setViewDataStatus(result.status)


      if (result.status === true) {
        setViewData(result.data)
        setupdStoreId(result.data.tool_transaction[0].store_id)
        setTrID(result.data.tool_transaction[0].id)
      // setPrintFlag(true)
      } else {
        setViewData([])
      }


    }else if(trTypeName === 'Transfer'){
      let result = await fetch(apiPath1 + "ToolIssueTransfer/" + id,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
  
      result = await result.json();
      setViewDataStatus(result.status)


      if (result.status === true) {
        setViewData(result.data)
        setupdStoreId(result.data.tool_transaction[0].store_id)
        setTrID(result.data.tool_transaction[0].id)
      // setPrintFlag(true)
      } else {
        setViewData([])
      }

    }else{
     
      let result = await fetch(apiPath1 + "ToolTransaction/" + id,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
  
      result = await result.json();
     
      setViewDataStatus(result.status)
     

      if (result.status === true) {
        
        setViewData(result.data)
        
        setupdStoreId(result.data.tool_transaction[0].store_id)
        
        setTrID(result.data.tool_transaction[0].id)
      
      // setPrintFlag(true)
      } else {
        setViewData([])
      }
    }
  

    openView()

    //  return

  }


  /* LIST OF ALL TR (for initial screen) */

  async function getTransactions() {

    let result = await fetch(apiPath1 + "ToolTransactions",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }

  async function getTransactionsByType(sType) {

    let result = await fetch(apiPath1 + "ToolTransactionByType/" + sType,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }

  async function getTransactionsBySelection(sType, sStore, sStatus, sDtFrom, sDtTo) {
    
 // alert('Type : '+sType+' Store : '+sStore+' Status : '+sStatus+' DtFrom : '+sDtFrom+' DtTo :'+sDtTo)
    
    if (sDtFrom != '' && sDtTo === '') {
      sDtTo = sDtFrom
    }

    let result = await fetch(apiPath1 + "ToolTransactionByTypeStoreStatusDate",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "transaction_type": sType,
          "store_id": sStore,
          "status": sStatus,
          "date_from": sDtFrom,
          "date_to": sDtTo
        })

      });
    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }


  function openTransaction(e) {

    switch (trType) {
      case 'I':
        OpenIssue()
      //  getReference("AllApprovedIndentsIdAndNumber", "")
      //  getReference("AllApprovedIndentsIdAndNumberNotOfOwnStore", "")
        getReferenceIndent("AllApprovedIndentsIdAndNumberNotOfOwnStore", "")
        clearToolDetails()
        return
      case "R":
        OpenReceipt()
        //getReference("IndentByStoreAndStatus","") 
        //getIndentByStore()
        return
      case 'T':
        OpenTransfer()
      //  getReference("AllApprovedIndentsIdAndNumber", "")
     //   getReference("AllApprovedIndentsIdAndNumberNotOfOwnStore", "")
        getReferenceIndent("AllApprovedIndentsIdAndNumberNotOfOwnStore", "")
        clearToolDetails()
        return
      case 'N':
        OpenReturn()
        return
      case 'U':
        OpenReturnReceipt()
        return
      case 'P':
        OpenPurchase()
        return
      case 'X':
        OpenRepair()
        return
      case 'Y':
        OpenRepairReceipt()
        return
      case 'O':
        return
      default:
        swal({
          title: "Information",
          text: "Select transaction type to add transaction",
          icon: "info",
          confirmButtonText: 'Cool',

        })
        // alert("Selected Transaction Type")
        return

    }

  }


  function openView() {
    setDisplayView(true)
  
  }

  function closeView() {
  //  setPrintFlag(false)
    setInvoiceData2([])
    setDisplayView(false)
  }

  function openUpdate() {
    setDisplayUpdate(true)
  }

  function closeUpdate() {
    setDisplayUpdate(false)
  }

  function openUpdateTrDet() {
//    setDisplayUpdateTrDet('block')
  }

  function closeUpdateTrDet() {
 //   setDisplayUpdateTrDet('none')
  }

  function closeIssue() {
    clearTransaction()
  // setDisplay(false)
    closeStorePop()
    setDisplayIssue(false)
  }

  function OpenIssue() {
    //setDisplay(true)
    setDisplayIssue(true)
  }

  function  openStoprePop(){
    if(toolNameId != 0) {
      setdisplayStorePop(true)
    }
  }

  function  closeStorePop(){
    setdisplayStorePop(false)
  }
  

  function OpenTransfer() {
    setDisplayTransfer(true)
  }

  function CloseTransfer() {
    clearTransaction()
    closeStorePop()
    setDisplayTransfer(false)
  }

  function OpenReturn() {
    setDisplayReturn(true)
  }

  function closeReturn() {
    clearTransaction()
    setDisplayReturn(false)
  }

  function closeReceipt() {
    clearTransaction()
    setDisplayReceipt(false)

  }

  function OpenReceipt() {
    setDisplayReceipt(true)
  }

  function OpenPurchase() {
    setDisplayPurchase(true)
  }

  function closePurchase() {
    clearTransaction()
    setDisplayPurchase(false)
  }

  function OpenRepair() {
    setDisplayRepair(true)
  }

  function closeRepair() {
    clearTransaction()
    setDisplayRepair(false)
  }

  function OpenRepairReceipt() {
    setDisplayRepairReceipt(true)
  }

  function closeRepairReceipt() {
    clearTransaction()
    setDisplayRepairReceipt(false)
  }

  function OpenReturnReceipt() {
    setDisplayReceiptReceipt(true)
  }

  function closeReturnReceipt() {
    clearTransaction()
    setDisplayReceiptReceipt(false)
  }

  //function trHandler(e) {
  //  e.preventDefault()
  //  setToolName(e.target.value)
  //}

  function indetDtUpdHandler(e) {
    e.preventDefault()
    setUpdTrDt(e.target.value)
  }

  function storeUpdHandler(e) {
    e.preventDefault()
    setupdStoreId(e.target.value)
  }

  function categoryHandler(e) {
    e.preventDefault()
    setCategory(e.target.value)
    getTools(e.target.value)
  }

  function categoryForPurchaseHandler(e) {
 //   alert(e.target.value)
    e.preventDefault()
    setCategory(e.target.value)
    getToolsForPurchase(e.target.value)
  }

  function updcategoryHandler(e) {

    e.preventDefault()
    setupdCategoryId(e.target.value)
    getTools(e.target.value)

  }

  function cpuHandler(e) {
    e.preventDefault()
    setCPU(e.target.value)
  }

  function cpuUpdHandler(e) {
    e.preventDefault()
    setupdCPU(e.target.value)
  }



  function qtyHandler(e) {
    e.preventDefault()
    setQTY(e.target.value)
   
  }

  function costHandler(e) {
    e.preventDefault()
    setCost(e.target.value)
  }

  function uomHandler(e) {
    e.preventDefault()
    setUOM(e.target.value)
  }

  function updqtyHandler(e) {
    e.preventDefault()
    setupdQty(e.target.value)
  }

  const [selectedTool,setSelectedTool] = useState(0)

  function toolHandler(e){
   
//  alert(e.target.value+',  '+selectedStoreValue)
    setSelectedTool(e.target.value)
    getAvlQty(e.target.value,selectedStoreValue)
    setSelectedToolName(e.target.options[e.target.selectedIndex].text)  
    closeStorePop()
  }

  function toolCodeHandler(e) {
    e.preventDefault()

   // alert(e.target.options[e.target.selectedIndex].text)
   
    setToolCode(e.target.value)
    setSelectedToolID(e.target.value)
    //setSelectedToolName(e.target.options[e.target.selectedIndex].text)
    getToolDetail(e.target.value)

    // const selectedOption = e.target.options[e.target.selectedIndex];
    // const selectedText = selectedOption.text;

    //console.log(tools[0].quantity)
    switch (trType) {
      case 'I':
        const selectedOption = (JSON.parse(e.target.value))
        const key = selectedOption.key
        setTQTY(tools[key].quantity)
        setSelectedUom(tools[key].uom)
        setSelectedToolCode(tools[key].tool_code)
      //  collectIndent(trDocId)
      //         return 
      /*      case "R":
              setTrTypeName("Receipt")
              return 
          case 'T':
              setTrTypeName("Transfer")
              return
          case 'N':
              setTrTypeName("Return")
              return 
          case 'P':
              setTrTypeName("Purchase")
              return 
          case 'X':
              setTrTypeName("Repair")
              return  */
      case 'O':
        // setTrTypeName("Opening")
        // setTrStatus("Completed")
        getToolDetail(e.target.value)
        return
      default:
      //        return setBtnTxt("Add Transaction")
    }
  }



  function updtoolCodeHandler(e) {
    e.preventDefault()
    setUpdToolCode(e.target.value)
    getToolDetail(e.target.value)
  }

  function updtoolTypeHandler(e) {
    e.preventDefault()
    setupdToolType(e.target.value)
  }


 // function updateTrHandler(e) {
 //   e.preventDefault()
 //   setUpdToolName(e.target.value)
 // }

  function toolTypeHandler(e) {
    e.preventDefault()
    setToolType(e.target.value)
  }

  function descHandler(e) {
    e.preventDefault()
    setDescription(e.target.value)

  }


const [selectedToolDesc,setSelectedToolDesc] = useState()

  async function getToolDetail(id) {

    //alert('ToolDetail '+id)

    let result = await fetch(apiPath1 + "Tool/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

   // alert(result.data[0].id)

    setSelectedUom(result.data[0].uom)
    setSelectedToolCode(result.data[0].tool_code)
    setSelectedToolName(result.data[0].tool_name)
    setSelectedToolDesc(result.data[0].tool_description)
    setSelectedToolID(result.data[0].id)
  }

  /* LIST OF ALL TOOL CATAGORY List */

  async function getToolCategory() {

    let result = await fetch(apiPath1 + "ToolCategories",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setCategoryData(result.data) }
    else { setCategoryData([]) }
  }


  /* LIST OF ALL TOOL CATAGORY BY USER */

  async function getToolCategoryByUser() {

    let result = await fetch(apiPath1 + "ToolCategoryByStoreTypeOfLinkedUser",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setCategoryForPurchaseData(result.data) }
    else { setCategoryForPurchaseData([]) }
  }

  /* LIST OF ALL STORES */
  async function getStores() {

    let result = await fetch(apiPath1 + "Stores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setStores(result.data) }
    else { setStores([]) }
  }

    /* LIST OF ALL STORES BY DEPARTMENT */
    async function getStoresByDept() {

      let result = await fetch(apiPath1 + "Stores",
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
      result = await result.json();
  
      if (result.status === true) { setStoresByDept(result.data) }
      else { setStoresByDept([]) }
    }

  /* LIST OF ALL SITE STORES */
  async function getSiteStores() {

   // alert(selectedRefIndent)

    let result = await fetch(apiPath1 + "SiteStores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setSiteStores(result.data) }
    else { setSiteStores([]) }
  }

    /* LIST OF ALL DEPARTMENT SITE STORES */
    async function getDeptSiteStores(api,id) {

 //   alert(api+', '+id)

      let result = await fetch(apiPath1 + api + id,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
      result = await result.json();
  
      if (result.status === true) { setDeptSiteStores(result.data) }
      else { setDeptSiteStores([]) }
    }

  /* LIST OF ALL SITE WAREHOUSE STORE */
  async function getWarehouseStores() {

    let result = await fetch(apiPath1 + "WarehouseStores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setWarehouseStores(result.data) }
    else { setWarehouseStores([]) }
  }


  /* LIST OF ALL SITE REPAIR STORE */
  async function getRepairShops() {

    let result = await fetch(apiPath1 + "RepairShops",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setRepairShops(result.data) }
    else { setRepairShops([]) }
  }

  /* LIST OF ALL TOOLS CATAGORYWISE */
  async function getTools(id) {

    let result = await fetch(apiPath1 + "ToolCategoryAndStatusWise",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "categoryId": id,
          "status": 'Ok'

        })
      });
    result = await result.json();

    if (result.status === true) { setTools(result.data) }
    else { setTools([]) }
  }


  /* LIST OF ALL TOOLS CATAGORYWISE FOR PURCHASE */
  async function getToolsForPurchase(id) {

   // alert('category '+id)

     let result = await fetch(apiPath1 + "ToolsForPurchase/" + id,
  //  let result = await fetch(apiPath1 + "ToolCategoryWise/" + id,
  //  let result = await fetch(apiPath1 + "DistinctToolNamesByCategory/"+id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    if (result.status === true) { setTools(result.data) }
    else { setTools([]) }
  }

  /* LIST OF ALL DAMAGED TOOLS  */
  async function getDamageTools(id) {

  // alert('Damaged tools '+id)

    let result = await fetch(apiPath1 + "DamagedToolsStoreWise/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    //  alert(result.status)

    if (result.status === true) { setToolsDamaged(result.data) }
    else { setToolsDamaged([]) }
  }

  //Add Transactio (Issue)


  async function addTransaction() {

    let ItemArray = CreateTrIssue()

    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": trRef,
      "store_id": trStore,
    }) + ',' + ItemArray + "]"

    //alert('Body :'+body)

    let result = await fetch(apiPath1 + "ToolTransactionAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    clearTransaction()
    getTransactionsByType(trType)
  }

  async function addIssueTransfer() {
  

    let ItemArray = CreateTrIssue()

    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": trRef,
      "store_id": trStore,
    }) + ',' + ItemArray + "]"

   // alert('Body :'+body)


    let result = await fetch(apiPath1 + "ToolIssueTransferAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    clearTransaction()
    getTransactionsByType(trType)
  }

  async function addReceivedReturnTransaction() {

    //   CreateTrReceipt()
    let ItemArray = CreateReceiptReturn()

    //alert(items)

    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": parseInt(trRef),
      "ref_doc_number": trRefDoc,
      "store_id": trStore,
      "indent_id": 0,
    }) + ',' + ItemArray + "]"

    //alert('Body: '+body)


    let result = await fetch(apiPath1 + "ToolTransactionReceiptAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    showSwal(result.status, result.msg)
    clearTransaction()
    getTransactionsByType(trType)
  }

  async function addReceivedTransaction() {


    let ItemArray = CreateTrReceipt()

    //alert(items)

    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": parseInt(trRef),
      "ref_doc_number": trRefDoc,
      "store_id": trStore,
      "indent_id": parseInt(indRef),
    }) + ',' + ItemArray + "]"

    //alert('Body: '+body)


    let result = await fetch(apiPath1 + "ToolTransactionReceiptAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    showSwal(result.status, result.msg)
    clearTransaction()
    getTransactionsByType(trType)
  }


  async function addRepairedItem() {


    let ItemArray = CreateTrRepairedItem()

    //  alert('TrREfDoc : '+trRefDoc)

    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": parseInt(trRef),
      "ref_doc_number": trRefDoc,
      "store_id": trStore,
      "indent_id": 0,
    }) + ',' + ItemArray + "]"

    //alert('Body: '+body)


    let result = await fetch(apiPath1 + "ToolTransactionReceiptAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    showSwal(result.status, result.msg)
    clearTransaction()
    getTransactionsByType(trType)
  }


  async function addRepairTransaction() {

    let ItemArray = CreateTrRepair()

    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": trRef,
      "store_id": trStore,
    }) + ',' + ItemArray + "]"

    //  alert('Body: '+body)



    let result = await fetch(apiPath1 + "ToolTransactionAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    showSwal(result.status, result.msg)
    clearTransaction()
    setRepairLineItem([])

    getTransactionsByType(trType)
  }



  async function addReturnedTransaction() {


    let ItemArray = CreateTrReturn()


    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": trRef,
      "store_id": trStore,
    }) + ',' + ItemArray + "]"

    //alert('Body: '+body)

    let result = await fetch(apiPath1 + "ToolTransactionAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

    showSwal(result.status, result.msg)
    clearTransaction()
    setReturnedItem([])

    getTransactionsByType(trType)
  }



  // function submitTr(){}

  function storeHandler(e) {

 //   alert(e.target.value)
    var typeName = trTypeName
    e.preventDefault()
    setSelectedStoreValue(e.target.value)


//alert(typeName)
    switch (typeName) {
      case "Issue":
        if (itemDetails.length >0) {
          swal('Cannot change  Store Now')
          setSelectedStoreValue(selectedStoreValue)
         // return
        }
        
        e.preventDefault()
        setTrStore(e.target.value)
        getInventoryByStoreId(e.target.value)
        getAvlQty(selectedTool,e.target.value)
        return
      case "Receipt":
        //alert('Receipt')
        e.preventDefault()
        setTrStore(e.target.value)
        getRefForReceipt(e.target.value)
        // getReference('PendingIndentByStoreAndStatus/',e.target.value)
        return
      case 'Transfer':
        //alert(e.target.value)

       // getReference('PendingIndentByStore/', e.target.value)

      //  getReferenceForTransfer()
        e.preventDefault()
        setTrStore(e.target.value)
        getInventoryByStoreId(e.target.value)
        getAvlQty(selectedTool,e.target.value)
        return
      case 'Return':
        //alert('Return')
        e.preventDefault()
        setTrStore(e.target.value)
        setRtndQty(returnedItem.map(() => ''))
        getRetutnDataByStoreId(e.target.value)

        return
      case 'Ret-Receipt':
        //alert('Return Receipt')
        e.preventDefault()
        setTrStore(e.target.value)
        getReturnedItemsList(e.target.value)

        return
      case 'Purchase':
        //alert('Purchase')
        e.preventDefault()
        setTrStore(e.target.value)

        return
      case 'Repair':
        //          setTrTypeName("Repair")
        e.preventDefault()
        setTrStore(e.target.value)
        getDamageTools(e.target.value)
        return
      case 'Repair Rcpt':
        //          setTrTypeName("Repd.Item Receipt")
  //alert("Repaired "+e.target.value)
        e.preventDefault()
        setTrStore(e.target.value)
        getPendingRepairedItems(e.target.value)
        return

      case 'Opening':
        e.preventDefault()
        setTrStore(e.target.value)
        return
      default:
      //        return setBtnTxt("Add Transaction")
    }

  }


  function warehouseStoreHandler(e) {
    e.preventDefault()
    setSelectedWarehouseStoreValue(e.target.value)
    setTrRef(e.target.value)
  }

  function storeHandlerRepairShop(e) {
    e.preventDefault()
    setSelectedRepairShop(e.target.value)
    setTrRef(e.target.value)
  }


  function refHandlerForRepairedItem(e) {


    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedText = selectedOption.text;

    setTrRefDoc(selectedText)

    e.preventDefault()
    setSelecteRepairdItem(e.target.value)
    setTrRef(e.target.value)
    getRepairedItems(e.target.value)

    setRepdQty(repdItems.map(() => ''))

  }

  function storeHandlerForReturn(e) {
    e.preventDefault()
    setSelectedStoreValue(e.target.value)
    setTrStore(e.target.value)
    //getReturnedItemsList(e.target.value)
    getInventoryByStoreId(e.target.value)

  }

  function TrNumberHandler(e) {
    e.preventDefault()
    setIndetNO(e.target.value)
  }

  function trDtHandler(e) {
    e.preventDefault()
    setSelectedDate(e.target.value)
    setTrDt(e.target.value)
  }

  function addTransactionDet(id, TrNo, TrDt, Store, trType, TrDocId) {

    // setTrType(e.target.value)
    //alert(id+', '+TrNo+', '+TrDt.substr(0,10)+', '+Store+', '+trType+', '+TrDocId)

    setTypeName(trType)
    setTrID(id)
    setTrNo(TrNo)
    setTrDt(TrDt.substr(0, 10))
    setStoreName(Store)
    setTrType(trType)
    setTrDocId(TrDocId)

    switch (trType) {
      case 'I':
        //alert('here')
        setInactiveCatelog(true)
        collectIndent(TrDocId)

      //    return 
      /*      case "R":
                setTrTypeName("Receipt")
                return 
            case 'T':
                setTrTypeName("Transfer")
                return
            case 'N':
                setTrTypeName("Return")
                return 
            case 'P':
                setTrTypeName("Purchase")
                return 
            case 'X':
                setTrTypeName("Repair")
                return */
      case 'O':
        // alert(trType)
        setInactiveCatelog(false)
      //setTrTypeName("Opening")
      //setTrStatus("Completed")

      default:
        setInactiveCatelog(false)
      //        return setBtnTxt("Add Transaction")
    }

    getTransactionItem(id)

    clearTransaction()
  }



  async function collectIndent(id) {
    //alert("collectIndent: "+id)
    let result = await fetch(apiPath1 + "PendingRefDocItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) {
      setIndentAvl(true)
      setTools(result.data)
    }
    else {
      setIndentAvl(false)
      setTools([])
    }


  }


  async function getTransactionItem(id) {

    //alert(inactiveCatelog)

    let result = await fetch(apiPath1 + "ToolTransactionItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) {
      setTrDetStat(true)
      setTrDet(result.data)
    }
    else {
      setTrDetStat(false)
      setTrDet([])
    }

    // setDisplay('block')

  }

  async function updateTransactionDetOperation(id) {


    let result = await fetch(apiPath1 + "ToolTransactionItem/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setupdTrID(result.data[0].tool_transaction_id)
    setupdToolID(result.data[0].tool_id)
    setupdQuantity(result.data[0].quantity)
    setupdUOM(result.data[0].uom)
    //  setUpdStatus(result.data.status)

    getCatagoty(result.data[0].tool_id)
    openUpdateTrDet()

  }


  async function getCatagoty(id) {
    // alert(id)
    let result = await fetch(apiPath1 + "Tool/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setCategoryId(result.data.tool_category_id)
    getTools(result.data.tool_category_id)
  }

  function deleteIndDetOperation(id) {


    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          DeleteTrDet(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  async function DeleteTrDet(id) {

    // alert(trID+", " +id)

    let result = await fetch(apiPath1 + "TrItemDelete/" + id,
      {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    showSwal(result.status, result.msg)

    getTransactionItem(trID)
  }



  function TransHandler(e) {


    if (e.target.value === '0') {

      getTransactions()
      clearFilter()
    } else {
      // getTransactionsByType(e.target.value)
      getTransactionsBySelection(e.target.value, selectedStore, selectedStatus, selectedDtFrom, selectedDtTo)
    }

    setTrType(e.target.value)
    setTypeName(e.target.value)

  }

  function clearFilter() {
    setSelectedStore('0')
    setSelectedStatus('')
    setSelectedDtFrom('')
    setSelectedDtTo('')
  }

  function setTypeName(type) {
    // alert('selecttype '+type)
    switch (type) {
      case '0':
        setTrTypeName("")
        return
      case 'I':
        setTrTypeName("Issue")
        setDeleteTrFlag(true)
        setModifyTrFlag(true)
        return
      case "R":
        setTrTypeName("Receipt")
        setDeleteTrFlag(false)
        setModifyTrFlag(true)
        return
      case 'T':
        setTrTypeName("Transfer")
        setDeleteTrFlag(true)
        setModifyTrFlag(true)
        return
      case 'N':
        setTrTypeName("Return")
        setDeleteTrFlag(true)
        setModifyTrFlag(true)
        return
      case 'U':
        setTrTypeName("Return Rcpt.")
        setDeleteTrFlag(true)
        setModifyTrFlag(true)
        return
      case 'P':
        setDisplayTransitButton('none')
        setTrTypeName("Purchase")
        setDeleteTrFlag(true)
        setModifyTrFlag(true)
        return
      case 'X':
        setDisplayTransitButton('none')
        setModifyTrFlag(false)
        setDeleteTrFlag(true)
        setTrTypeName("Repair")
        return
      case 'Y':
        setDisplayTransitButton('none')
        setModifyTrFlag(false)
        setDeleteTrFlag(true)
        setTrTypeName("Repair Rcpt")
        return
      case 'O':
        setTrTypeName("Opening")
        setTrStatus("Completed")
        return
      case 'C':
          setTrTypeName("Calibration")
          return
      default:
      //        return setBtnTxt("Add Transaction")
    }
  }


  function refHandler(e) {
    //  alert(e.target.value)

    setItemDetails([])

    setQuantities(itemDetails.map(() => ''))

    e.preventDefault()
    setSelectedRefValue(e.target.value)
    setTrRef(e.target.value)

  //  getPendingIndent(e.target.value)

    //getItems("PendingIndentItems/",e.target.value)

  }

  function refIndentHandler(e) {

    setItemDetails([])

    setQuantities(itemDetails.map(() => ''))

    e.preventDefault()
    //setSelectedRefValue(e.target.value)
    setSelectedRefIndent(e.target.value)
    setTrRef(e.target.value)

    getToolName(e.target.value)



    //getItems("PendingIndentItems/",e.target.value)

    if(trTypeName === 'Issue'){
      getDeptSiteStores('WarehouseStoresForIssue/',e.target.value)
    }else if(trTypeName === 'Transfer'){
      getDeptSiteStores('SiteStoresForTransfer/',e.target.value)
    }else{
      getSiteStores()
    }

  }

  const [toolNames,setToolNames] = useState([])
  const [CurrentIndentId, setCurrentIndentId] = useState()
  const [toolNameId, setToolNameId] = useState()

  async function getToolName(id){

    //alert(id)

    setCurrentIndentId(id)

    let result = await fetch(apiPath1 + "ToolNamesInIndent/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    if (result.status === true) {
      setToolNames(result.data)
    }else{setToolNames([])}

   // setCategoryId(result.data.tool_category_id)
   // getTools(result.data.tool_category_id)


  }

  /*
  async function getPendingIndent(id) {

    let result = await fetch(apiPath1 + "PendingIndentItems/" + id,
      let result = await fetch(apiPath1 + "PendingIndentItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    if (result.status === true) { setItemDetails(result.data) }
    else { setItemDetails([]) }

  }
  */


  async function getPendingIndent(storeID,IndentId) {

  //  alert('onClick '+storeID+', '+IndentId)
  //  alert(trRef+', '+trStore)

   // return

    let result = await fetch(apiPath1 + "IndentPendingItemInventoryDetail",
     
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "indent_id":IndentId,
          "store_id":storeID
        })
      });

      result = await result.json();

    if (result.status === true) { setItemDetails(result.data) }
    else { setItemDetails([]) }

  }


  function refHandlerForIssuedIndent(e) {
    //alert(e.target.value)

    //const selectedOption = e.target.options[e.target.selectedIndex];
    //const selectedText = selectedOption.text;

    e.preventDefault()
    setSelectedIndent(e.target.value)
    setIndref(e.target.value)

    getIssuedItemsList(e.target.value)
  }


  function refHandlerForReceipt(e) {


    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedText = selectedOption.text;


    //alert(selectedText)

    e.preventDefault()
    setSelectedIssuedItem(e.target.value)
    setTrRef(e.target.value)
    setTrRefDoc(selectedText)

    setIssuedItems([])

    setRcvdQty(issuedItems.map(() => ''))

    getIssuedItemForReceipt(e.target.value)
  }

  function refHandlerForReturn(e) {


    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedText = selectedOption.text;


    //alert(selectedText)

    e.preventDefault()
    setSelectedReturnedRef(e.target.value)
    setTrRef(e.target.value)
    setTrRefDoc(selectedText)

    setRetItems([])

    setRcvdRetQty(returnedItem.map(() => ''))

    getReturnedItemForReceipt(e.target.value)
  }



  async function getIssuedItemForReceipt(id) {

    // alert('Get Issued Item for Display '+id)

    let result = await fetch(apiPath1 + "ToolTransactionItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    //alert('issued Item for receipt found '+result.status)

    setIssuedItemStatus(result.status)
    if (result.status === true) {
      setIssuedItems(result.data)

    }

    else {
      setIssuedItems([])
    }
  }



  async function getReturnedItemForReceipt(id) {

    // alert('Get returned Item for Display '+id)

    let result = await fetch(apiPath1 + "ToolTransactionItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    //alert('returned Item for receipt found '+result.status)

    setRetItemStatus(result.status)
    if (result.status === true) {
      setRetItems(result.data)

    }

    else {
      setRetItems([])

    }
  }


  async function getIssuedItemsList(id) {

    // alert('GetIssuItemList '+id)

    let result = await fetch(apiPath1 + "ToolTransactionOnTransitByRefDoc/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    //alert('issued Item List '+result.status)

    setIssuedItemListStatus(result.status)
    if (result.status === true) { setIssuedItemsList(result.data) }

    else { setIssuedItemsList([]) }

    //CreateIssueArray()

  }


  async function getReturnedItemsList(id) {

    //alert('GetReturnItemList '+id)  /* InventoryByStore */

    let result = await fetch(apiPath1 + "OnTransitReturnByRefDoc/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    //alert('Return List '+result.status)

    setReturnedItemListStatus(result.status)

    if (result.status === true) { setReturnedItemsList(result.data) }

    else { setReturnedItemsList([]) }

    //CreateIssueArray()

  }


  async function getItems(apiName, apiPara) {

    //alert(apiPath1+apiName+apiPara)

    let result = await fetch(apiPath1 + apiName + apiPara,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    //alert(result.status)

    //console.log('data :',result.data)

    if (result.status === true) { setItemDetails(result.data) }

    else { setItemDetails([]) }

    //CreateIssueArray()

  }


  //List of Ref. Documents (Such as Indent etc.)

  async function getReference(apiName, apiPara) {
    //alert(apiPath1+', '+apiName+', '+apiPara)


    let result = await fetch(apiPath1 + apiName + apiPara,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    console.log('data :', result.data)
    if (result.status === true) { setRefData(result.data) }
    else { setRefData([]) }

  }

  const [refIndent, setRefIndent] = useState([])

    //List of Ref. Indent Documents (Such as Indent etc.)

    async function getReferenceIndent(apiName, apiPara) {
     
    // alert(apiName+'....'+apiPara)
 
 
     let result = await fetch(apiPath1 + apiName + apiPara,
       {
         method: 'GET',
         headers: {
           "Content-Type": "application/json",
           "Accept": "application/json",
           "Authorization": `Bearer ${token}`
         },
       });
 
     result = await result.json();
 
     //console.log('data :', result.data)
     if (result.status === true) { setRefIndent(result.data) }
     else { setRefIndent([]) }
 
   }

  const [trfrRefData, setTrfrRefData] = useState([])


  //List of Ref. Documents For Transfer (Such as Indent etc.)

  async function getReferenceForTransfer() {
    //alert(apiPath1+apiName+apiPara)


    let result = await fetch(apiPath1 + "PendingIndentNotOfOwnStore",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    console.log('data :', result.data)
    if (result.status === true) { setTrfrRefData(result.data) }
    else { setTrfrRefData([]) }

  }

  async function getRefForReceipt(id) {
    //alert('getRefForReceipt'+id)

    let result = await fetch(apiPath1 + "IndentByStoreAndStatus",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "storeId": id,
          "status": "Approved"
        })
      });

    result = await result.json();

    //alert(result.status)
    setRefStatus(result.status)
    if (result.status === true) { setRefIndentData(result.data) }
    else { setRefIndentData([]) }

  }


  /* LIST OF ALL INVENTORY BY STORE */

  async function getInventoryByStoreId(id) {

    let result = await fetch(apiPath1 + "InventoryByStore/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();


    setInventoryDataStatus(result.status)
    if (result.status === true) { setInventoryData(result.data) }
    else { setInventoryData([]) }
  }


  async function getRetutnDataByStoreId(id) {


    let result = await fetch(apiPath1 + "InventoryByStore/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    setReturnedItemStatus(result.status)
    if (result.status === true) { setReturnedItem(result.data) }
    else { setReturnedItem([]) }
  }


  const handleQuantityChange = (index, value, issuedQty, iQty) => {
   //alert('handleQty : '+index+','+value+', '+issuedQty+', '+iQty)
    if (value > (iQty - issuedQty) || value < 0) {
      quantities[index] = 0
      setQuantities(quantities);
      swal({
        title: "Fail!",
        text: "Quantity "+value+ " ???. Issue Quantity cannot be Zero or more than Available Indent Quantity",
        icon: "error",
        button: "OK!",
      });
    } else {
      const newQuantities = [...quantities];
      newQuantities[index] = value;
      setQuantities(newQuantities);
    }
  };


  const handleRcvdQuantityChange = (index, value, iQty) => {
    // alert(index+' , '+value+', '+iQty)

    if (value > iQty || value < 0) {
      swal({
        title: "Fail!",
        text: "Received Quantity cannot Zero or more than Issued Quantity",
        icon: "error",
        button: "OK!",
      });
    } else {

      const newQuantities = [...rcvdQty];
      newQuantities[index] = value;
      setRcvdQty(newQuantities);

      console.log('rcvd', rcvdQty)
    }
  };

  const handleRepairedQuantityChange = (index, value, iQty) => {
    // alert(index+' , '+value+', '+iQty)

    if (value > iQty || value < 0) {
      swal({
        title: "Fail!",
        text: "Received Quantity cannot Zero or more than repaired Quantity",
        icon: "error",
        button: "OK!",
      });
    } else {

      const newQuantities = [...repdQty];
      newQuantities[index] = value;
      setRepdQty(newQuantities);

      console.log('repd', repdQty)
    }
  };

  const handleRcvdRetQuantityChange = (index, value, iQty) => {
    // alert('Received Retrun Qty '+index+' , '+value+', '+iQty)

    if (value > iQty || value < 0) {
      swal({
        title: "Fail!",
        text: "Received Quantity cannot Zero or more than Issued Quantity",
        icon: "error",
        button: "OK!",
      });
    } else {

      const newQuantities = [...rcvdRetQty];
      newQuantities[index] = value;
      setRcvdRetQty(newQuantities);

 //     console.log('rcvd', rcvdRetQty)
    }
  };

  const handleReturnQuantityChange = (index, value, iQty) => {
    // alert(index+' , '+value+', '+iQty)

    if (value > iQty || value < 0) {
      swal({
        title: "Fail!",
        text: "Returned Quantity cannot Zero or more than Store Quantity",
        icon: "error",
        button: "OK!",
      });
    } else {

      const newQuantities = [...rtndQty];
      newQuantities[index] = value;
      setRtndQty(newQuantities);

      console.log('rtnd', JSON.stringify(rtndQty))
    }
  };

  const CreateTrIssue = () => {
    const newData = itemDetails.map((tool, index) => [{
      'tool_id': tool.tool_id,
      'uom': tool.uom,
      'quantity': tool.quantity, // quantities[index] || 0 // Default to 0 if empty   
      'indent_item_id': tool.tool_name_id
    }]);

    let ItemString = createDataString(newData)

    return ItemString
  };

  const CreateTrReturn = () => {

    const newData = returnedItem.map((tool, index) => [{
      'tool_id': tool.tool_id,
      'uom': tool.uom,
      'quantity': rtndQty[index] || 0 // Default to 0 if empty   
    }]);


    let ItemString = createDataString(newData)

    return ItemString

  };



  const CreateTrRepair = () => {

    const newData = repairLineitem.map((tool, index) => [{
      'tool_id': tool.tool_id,
      'uom': tool.uom,
      'quantity': tool.quantity
    }]);

    //      setSavedData(newData);
    //     console.log('NewData ',JSON.stringify(newData))
    let ItemString = createDataString(newData)

    return ItemString

  };


  const CreateReceiptReturn = () => {

   // console.log('RECE RET QTY', JSON.stringify(rcvdRetQty))

    const newData = retItems.map((tool, index) => [{
      'tool_id': tool.tool_id,
      'quantity': tool.quantity,
      'quantity_rcvd': parseInt(rcvdRetQty[index]) || '0', // Default to 0 if empty  
      'uom': tool.uom
    }]);

    //  console.log('NewData ',JSON.stringify(newData))
    let ItemString = createDataString(newData)

    return ItemString

  };


  function createDataString(newData) {

    //alert('NewData '+JSON.stringify(newData))
    setItems([])
    const newItems = [];
    for (let i = 0; i < newData.length; i++) {
      newItems[i] = JSON.stringify(newData[i]).substring(1, JSON.stringify(newData[i]).length - 1)
    }

    setItems(newItems)
    //alert('NewItem '+newItems)

    return newItems


  }



  const CreateTrRepairedItem = () => {

    const newData = repairedItems.map((tool, index) => [{
      'tool_id': tool.tool_id,
      'quantity': tool.quantity,
      'quantity_rcvd': parseInt(repdQty[index]) || '0', // Default to 0 if empty  
      'uom': tool.uom
    }]);

    let ItemString = createDataString(newData)

    return ItemString

  };

  const CreateTrReceipt = () => {

    const newData = issuedItems.map((tool, index) => [{
      'tool_id': tool.tool_id,
      'quantity': tool.quantity,
      'quantity_rcvd': parseInt(rcvdQty[index]) || '0', // Default to 0 if empty  
      'uom': tool.uom
    }]);

    let ItemString = createDataString(newData)

    return ItemString

  };

  const CreatePurchaseItem = () => {

    // console.log('RECE RET QTY',JSON.stringify(lineitem))

    const newData = lineitem.map((tool, index) => [{
      'tool_id': tool.tool_id,
      'quantity_rcvd': tool.quantity,
      'purchase_cost': tool.cost,
      'uom': tool.uom
    }])


    let ItemString = createDataString(newData)

    return ItemString


    //setItemReady(x)

    //alert('create : '+x)

  }

  async function updateItemOperation(id, stat) {
    // alert('update ::'+id+', '+updStoreId+', Status :'+stat+'.')
    //if (trType != "0")

    if (stat === 'Pending') {

    }
    else {

      swal({
        title: "Fail!",
        text: stat + " transaction cannot be editable",
        icon: "error",
        button: "OK!",
      });
      return
    }

    let result = await fetch(apiPath1 + "ToolTransactionItem/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();



    setUpdItemId(id)
    setupdToolID(result.data[0].tool_id)

    setupdQty(result.data[0].quantity)
    openUpdateIssueDet()

  }

  function openUpdateIssueDet() {
    setDisplayUpdateIssueDet(true)
  }

  function closeUpdateIssueDet() {
    setDisplayUpdateIssueDet(false)
  }

  async function updateLineItem() {

    //alert(updItemId+', '+updQty+', '+updStoreId+', '+updToolId+','+updTrId) 

    let result = await fetch(apiPath1 + "ToolTransactionItemUpdate", {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": updItemId,
        "quantity": updQty,
        "store_id": updStoreId,
        "tool_id": updToolId
      })
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    closeUpdate()

    updateOperation(updTrId)
    getInventoryByStoreId(updStoreId)

  }



  function deleteItemOperation(id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteItem(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }


  async function deleteItem(id) {

    //alert(id+', '+updStoreId) 

    let result = await fetch(apiPath1 + "ToolTransactionItemDelete", {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "store_id": updStoreId
      })
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    updateOperation(updTrId)
    getInventoryByStoreId(updStoreId)

  }


  function deleteTransferIssue(id, tool_name_id,qty) {

  //  alert(id, tool_name_id)

    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          handleDeleteRow(id, tool_name_id,qty);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  const handleDeleteRow = (id, toolNameId,qty) => {
    // alert(id)

    if (lineIndentitem.some(row => row.tool_name_id === toolNameId)){
      setLineIndentItem(prevItems => 
        prevItems.map(item => 
          item.tool_name_id === toolNameId ? { ...item,  tool_bal_indnet_qty: item. tool_bal_indnet_qty + qty } : item
        )
      )
    }

    const updatedItems = itemDetails.filter(item => item.id !== id);
    setItemDetails(updatedItems);





    return true



    /**
                 ... lineIndentitem,
            {
              tool_name_id:toolNameId,
              tool_bal_indnet_qty:(indentQty - qtyIssued) - qty

              item.tool_name_id
     */
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  async function setOnTransit(id) {
    // alert(id)

    let result = await fetch(apiPath1 + "ToolTransactionOnTransit/" + id, {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    //alert(trType)

    getTransactionsByType(trType)

  }

  function addLineItem() {
 
   // alert(selectedToolID+', '+ selectedToolCode +', '+selectedToolName+', '+qty)
 
    if (qty === undefined || qty <= 0 || selectedToolID === undefined) {
      swal({
        title: "Fail!",
        text: "Quantity be must be more than Zero",
        icon: "error",
        button: "OK!",
      });
      return
    }

    if (cost === undefined || qty <= 0 || selectedToolID === undefined) {
      swal({
        title: "Fail!",
        text: "Cost be must be more than Zero",
        icon: "error",
        button: "OK!",
      });
      return
    }

    setLineItem(
      [
        ...lineitem,
        {
          id: lineitem.length+1,
          tool_code: selectedToolCode,
          tool_id: selectedToolID,
      //    tool_name: selectedToolName, Change to Description at the Time Purchase Module Modification
          tool_name: selectedToolDesc,
          quantity: qty,
          cost: cost,
          uom: selectedUom
        }
      ]
    );
    setLineItemStatus(true)
  }


  function addIssueLineItem() {
   //  alert(selectedTool+', '+selectedToolName+', '+qty+', '+avlblQty)
   
  

    if (qty === undefined || qty <= 0 || selectedTool === undefined || qty > avlblQty) {
      swal({
        title: "Fail!",
        text: "Quantity be must be between Zero and available Quantity",
        icon: "error",
        button: "OK!",
      });
      return
    }

    if (itemDetails.some(row => row.tool_id === selectedTool)){
      swal({
        title: "Fail!",
        text: "Tool already exist",
        icon: "error",
        button: "OK!",
      });
      return
    }

    const foundTool = lineIndentitem.find(row => row.tool_name_id === toolNameId)
   
    if (foundTool) {
      //const toolName = foundTool.tool_name;
      //console.log(toolName);

        if (foundTool.tool_bal_indnet_qty === 0){
          swal({
            title: "Fail!",
            text: "Indent Quantity is Zero",
            icon: "error",
            button: "OK!",
          });
          return
        }
      }

     
    //lineIndentitem

    setItemDetails(
      [
        ...itemDetails,
        {
          id: itemDetails.length +1,
          tool_id: selectedTool,
          tool_code: selectedTool,
          tool_name_id : toolNameId,
          tool_name: selectedToolName,
          quantity: qty,
          tool_name_id : toolNameId,
      //    cost: cost,
          uom: uom
        }
      ]
    );
    //setLineItemStatus(true)

    if (lineIndentitem.some(row => row.tool_name_id === toolNameId)){
      setLineIndentItem(prevItems => 
        prevItems.map(item => 
          item.tool_name_id === toolNameId ? { ...item,  tool_bal_indnet_qty: item. tool_bal_indnet_qty - qty } : item
        )

      )
    }else{
        setLineIndentItem(
          [
            ... lineIndentitem,
            {
              tool_name_id:toolNameId,
              tool_bal_indnet_qty:(indentQty - qtyIssued) - qty
            }
          ]
        );
      }


    clearLineItems()
  }

  function clearLineItems(){
   
    setQTY(0)
    setToolNameId("0")   
    setSelectedTool("0")
    setQtyIssued(0)
    setAvlblQty(0)
    setIndentQty(0)
    setUOM('')
   
  }

  function clearToolDetails(){
    setTools([])
    setToolNames([])
    setCurrentIndentId()
    clearLineItems()
  }



  function addRepairItem() {
    // alert(selectedToolCode+', '+selectedToolName+', '+qty)
    if (qty === undefined || qty <= 0 || selectedToolCode === undefined) {
      swal({
        title: "Fail!",
        text: "Quantity be must be more than Zero",
        icon: "error",
        button: "OK!",
      });
      return
    }

    setRepairLineItem(
      [
        ...lineitem,
        {
          id: lineitem.length,
          tool_code: selectedToolCode,
          tool_id: selectedToolID,
          tool_name: selectedToolName,
          quantity: qty,
          uom: selectedUom
        }
      ]
    );
    setRepairLineItemStatus(true)

  }


  async function getPendingRepairedItems(id) {

   // alert(id)

//    let result = await fetch(apiPath1 + "ToolTransactionByStoreTypeStatus",
    let result = await fetch(apiPath1 + "ToolTransactionByTypeStoreStatusDate",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "store_id": id,
          "transaction_type": 'X',
          "status": "Pending",
          "date_from":'',
          "date_to":''
        })
      });

    result = await result.json();

    //alert(result.status)

    setPendingItemStatus(result.status)
    if (result.status === true) {
      setPendingRepairedItems(result.data)
    } else {
      setPendingRepairedItems([])
    }

  }


  async function getRepairedItems(id) {

    let result = await fetch(apiPath1 + "ToolTransactionItems/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setRepairedItemStatus(result.status)
    if (result.status === true) {
      setRepairedItems(result.data)
    } else {
      setRepairedItems([])
    }

  }

  async function addPurchase() {

    //setLoading(false)
    //setItemReady(false)

    let ItemArray = CreatePurchaseItem()

    //setItemReady(true)
    //alert('Items : '+items)

    let body = "[" + JSON.stringify({
      "transaction_type": trType,
      "transaction_date": trDt,
      "ref_doc_id": parseInt(trRef),
      "ref_doc_number": poNumber,
      "store_id": trStore,
      "indent_id": 0
    }) + ',' + ItemArray + "]"

    //alert('Body: '+body)

    //     setItems([])
    setLoading(false)

    let result = await fetch(apiPath1 + "ToolTransactionReceiptAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: body
    });

    result = await result.json();

if (result.status !== undefined ){  

       clearTransaction()
   
       showSwal(result.status, result.msg)
       body = ""

       closePurchase()
}
else{
       showSwal(result.status, result.msg)
       body = ""
}
   
    getTransactionsByType(trType)

  }

  function clearTransaction() {
    // alert('clearTransaction')

    //Issue Form
    setInventoryDataStatus(false); setInventoryData([]); setSelectedDate('');
    setItemDetails([]); setSelectedStoreValue('0'); setSelectedRefValue('0');

    setSelectedRefIndent('0')

    //Receipt Form
    setIssuedItemStatus(false); setIssuedItems([]);
    setRefStatus(false); setRefIndentData([]); setSelectedIssuedItem('0');
    setIssuedItemListStatus(false); setIssuedItemsList([]);
    setSelectedIndent('0');

    //Transfer Form 
    setReturnedItemListStatus(false); setReturnedItemsList([]);

    //Return Form
    setSelectedWarehouseStoreValue('0');
    setReturnedItemStatus(false); setRetItems([]);

    //Return receipt form
    setSelectedReturnedRef('0')
    setRetItemStatus(false); setRetItems([]);

    //Purchase Form


    //Repair Form
    setSelectedRepairShop('0')
    setRepairLineItem([]); setRepairLineItemStatus(false);

    //Repaired Receipt Form
    setPendingItemStatus(false); setPendingRepairedItems([]);
    setRepairedItemStatus(false); setRepairedItems([]);
    setPendingItemStatus(false); setSelecteRepairdItem('0')

    setLineItem([])
    setPONumber('')
    setTrDt('')
    setTrStore('0')
    setTrRef('0')
    setCategory('0')
    setToolCode('0')
    setQTY('')
    setCost('')
    setSelectedUom('')

    setPrintId(0)
    setPrintFlag(false)
    setLoading(false)
  }

  // const [selectedTransaction, setSelectedTransaction] = useState('0') setTrType
  const [selectedStore, setSelectedStore] = useState('0')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [selectedDtFrom, setSelectedDtFrom] = useState('')
  const [selectedDtTo, setSelectedDtTo] = useState('')

  function storeSelector(e) {
    //alert(trType+', Store :'+e.target.value+', Status '+selectedStatus)
    e.preventDefault()
    setSelectedStore(e.target.value)
    getTransactionsBySelection(trType, e.target.value, selectedStatus, selectedDtFrom, selectedDtTo)

  }

  function statusHandler(e) {
    //alert(trType+', Store :'+selectedStore+', Status '+e.target.value)
    e.preventDefault()
    setSelectedStatus(e.target.value)
    getTransactionsBySelection(trType, selectedStore, e.target.value, selectedDtFrom, selectedDtTo)
  }

  function fromDtHandler(e) {
    e.preventDefault()
    setSelectedDtFrom(e.target.value)
    getTransactionsBySelection(trType, selectedStore, selectedStatus, e.target.value, selectedDtTo)
  }

  function toDtHandler(e) {
    e.preventDefault()
    setSelectedDtTo(e.target.value)
    getTransactionsBySelection(trType, selectedStore, selectedStatus, selectedDtFrom, e.target.value)

  }

    async function getInvoice(id){

      //alert('Print id '+id)
        setLoading(true)
 
         let result = await fetch(apiPath1 + "printReturnableChallan/"+id,
            {
              method: 'GET',
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`
              },
            });
            
          result = await result.json();

          setInvoiceStatus(result.status)

      
          if (result.status === true) { 
            setLoading(false)
            setInvoiceData2(result) 
          }
          else { 
            swal('Data Not Present !!')
            setLoading(false)
            setInvoiceData2([]) }
  
          
    }

    const [toolName,setToolName] = useState()

    function getToolsFromIndent(e){
      //alert(e.target.value)
      //alert(e.target.options[e.target.selectedIndex].text)
      setAvlblQty(0)
      getAvlQty(selectedTool,selectedStoreValue)
      setToolNameId(e.target.value)
      setToolName(e.target.options[e.target.selectedIndex].text)

      getIndentDetails(CurrentIndentId,e.target.options[e.target.selectedIndex].text)
      getToolList(e.target.options[e.target.selectedIndex].text)

      getToolsByStore(e.target.options[e.target.selectedIndex].text)
     // openStoprePop()
      
    }

    const [possibleStores,setPossibleStores] = useState([])

    async function getToolsByStore(toolName){
     // alert(toolName)

      let result = await fetch(apiPath1 + "InventoryByToolNameInAllStores/"+toolName,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
        
      result = await result.json();

     // alert(result.status)


      if (result.status === true){
        setPossibleStores(result.data)
      } else{
        setPossibleStores([])
        closeStorePop()
      }


    }

    const [qtyIssued, setQtyIssued] = useState(0)
    const [indentQty, setIndentQty] = useState(0)
    const [avlblQty, setAvlblQty] = useState(0)

    async function getIndentDetails(id,toolName){

      //alert(id+', '+toolName)

      let result = await fetch(apiPath1 + "IndentQtyForToolName", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
        "indentId": id,
        "toolName" : toolName
       })
      });

      result = await result.json();

      if (result.status === true){
        
        setIndentQty(result.data.quantity)
        setQtyIssued(result.data.qty_issued)
        setUOM(result.data.uom)
      }

    }

    async function getToolList(toolName){

    //  alert(toolName)

      let result = await fetch(apiPath1 + "ToolsByToolName/"+toolName,
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
        
      result = await result.json();


      if (result.status === true){
        setTools(result.data)
      }else{
        setTools([])
      }
      
    }

    async function getAvlQty(toolid,storeid){
    //  alert(toolid+', '+storeid)

      let result = await fetch(apiPath1 + "ToolQuantityInStore",
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            "storeId": storeid,
            "toolId": toolid
          })
        });
  
      result = await result.json();

      if (result.status === true){
        setAvlblQty(result.data.quantity-result.data.qty_in_use)
      } else{
        setAvlblQty(0)
      }

    }


  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Transaction Document List'} />

      <div className="row p16 " style={{ 'height': '95%' }}>
        <div className="c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
          {/* CTA SECTION */}
          <div className="row mb16">
            {/* SELECT FILTER SECTION */}
            <div className="c12-g-l-2">
              <p className='txt-darkblue' style={{ 'marginLeft': '4px' }}>Transaction Type</p>
              <select className="small" value={trType} onChange={TransHandler}>
                <option value="0">All Transactions</option>
                <option value="I">Issue</option>
                <option value="R">Receipt</option>
                <option value="T">Transfer</option>
                <option value="N">Return</option>
                <option value="U">Return-Receipt</option>
                <option value="P">Purchase</option>
                <option value="X">Repair</option>
                <option value="Y">Repaired Item Receipt</option>
                <option value="O">Opening</option>
              </select>
            </div>
            <div className="c12-g-l-2">
              <p className='txt-darkblue ml4'>Store</p>
              <select className="small" value={selectedStore}
                onChange={storeSelector}>
                <option value="0" >All Stores</option>
                {
                  storedata.map((item, index) =>
                    <option key={item.id} value={item.id}>{item.store_name}</option>
                  )
                }
              </select>
            </div>
            <div className="c12-g-l-1">
              <p className='txt-darkblue ml4'>Status</p>
              <select className="small" value={selectedStatus}
                onChange={statusHandler}>
                <option value="">All Status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Closed">Closed</option>
                <option value="Rejected">Rejected</option>
                <option value="On-Transit">On Transit</option>
              </select>
            </div>
            <div className="c12-g-l-2">
              <p className='txt-darkblue ml4 mb4'>Date From</p>
              <input type="date" className="box small" onChange={fromDtHandler} value={selectedDtFrom}
                style={{ "width": '98%', 'marginTop': '1px' }} />
            </div>
            <div className="c12-g-l-2">
              <p className='txt-darkblue ml4 mb4'>Date To</p>
              <input type="date" className="box small" onChange={toDtHandler} value={selectedDtTo}
                style={{ "width": '98%', 'marginTop': '1px' }} />

            </div>



            {/* ADD BUTTON */}
            {
              (trTypeName !== 'Opening' && trTypeName !== '' ?
                (
                  <div className="c12-g-l-3 align-bottom-right">
                    <button onClick={openTransaction} type="button" name="button"
                      style={{ "marginTop": "25px" }}
                      className="btn gradient round large">New {trTypeName}</button>
                  </div>
                )
                : <div></div>)
            }
          </div>


          {/* MAIN DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4" style={{ 'height': '85%' }}>
            <table style={{ 'display': 'block' }}>
              <thead className='thead-blue'>
                <tr>
              {/*  <th className="th-border" width="5%">Id</th> */}
                  <th className="th-border left" width="5%">Type</th>
                  <th className="th-border" width="15%">Date</th>
                  <th className="th-border left" width="15%">Tr.Code</th>
                  <th className="th-border left" width="15%">Ref. Doc. Code</th>
                  <th className="th-border left" width="15%">Store</th>
                  <th className="th-border left" width="10%">Status</th>
                  <th className="th-border left" width="25%">User Name</th>
                  <th className="th-border" width="15%">View</th>
                  <th className="th-border" width="15%">Edit</th>
              {/*    <th className="th-border" width="15%">Delete</th>  */}
                </tr>
              </thead>
              <tbody >
                {
                  data.map((item, index) =>
                    <tr className="tr-two-color-grey" key={index}>
                   {/*   <td className="center">{item.id}</td>  */}
                      <td className="">{item.transaction_type}</td>
                      <td className="center" style={{ 'fontSize': '12px' }}>{item.transaction_date.substr(0, 10)}</td>
                      <td className="">{item.transaction_code}</td>
                      <td className="">{item.ref_doc_code}</td>
                      <td className="">{item.store_name}</td>
                      <td className="">{item.status}</td>
                      <td className="">{item.user_name}</td>
                      <td onClick={() => { View(item.id) }} className="center"><img src={require('../asset/icons/adm_view_16.png')} alt="" /></td>

                      {
                        (item.status === 'Pending' ?
                          (
                            <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                          )
                          : <td className="center"><img src={require('../asset/icons/adm_edit_disabled.png')} alt="" /></td>
                        )}



                      
                {/*      <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>  */}
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>

        {/* A.SCREEN FROM ADDING NEW Transaction - Issue */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayIssue && (  
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-3">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-8"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeIssue}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <div className="row">
                    <div className='c12-l-3 pr12'>
                      <p>Select Indent</p>
                      <select className="small" onChange={refIndentHandler} style={{ "width": '98%', 'marginTop': '1px' }} value={selectedRefIndent}>
                        <option value="0" >Select Reference</option>
                        {
                          refIndent.map((item, index) =>
                            <option key={item.indentId} value={item.indentId}>{item.indentCode}</option>
                          )
                        }
                      </select>
                    </div>

                    <div className='c12-l-2 pr12'>                     
                      <p>{trTypeName} Date</p>
                      <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={trDtHandler} />                    
                    </div>

                    <div className='c12-l-2 pr12'>
                      <p>{trTypeName} Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New" value={trNo} disabled={true} />
                    </div>

                    <div className='c12-l-3 pr4'>
                      <p>Select Warehouse From</p>
                      <select value={selectedStoreValue} className="small" onChange={storeHandler} style={{ 'marginTop': '1px' }} >
                        <option value="0" >Select Store</option>
                        {
                          deptSiteStoredata.map((item, index) =>
                            <option key={item.store_id} value={item.store_id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>  
                    
                    <div className='c12-l-2'>
                    <button onClick={addIssueLineItem} name='qty' type="button" style={{ 'marginTop': '22px', 'width': '90%' }}
                      className="btn gradient round">Add Tools</button>
                  </div>
                  </div>

                  <div className="row">
                    <div className='c12-l-3'>
                      <div className="row">
                        <div className="c12-l-10">
                          <p style={{ 'marginTop': '5px' }}>Select Tool Name</p>
                          <select className="small" onChange={getToolsFromIndent} style={{ "width": '98%', 'marginTop': '1px' }} value = {toolNameId}>
                            <option value="0" >Select Tool Name</option>
                            {
                              toolNames.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.tool_name}</option>
                              )
                            }
                          </select>
                        </div>
                        <div className="c12-g-l-1">
                          <img title="Show Inventory" onClick={openStoprePop} src={myImage} alt="Button Icon" style={{ marginTop: '22px', width: '35px', height: '35px', marginRight: '5px' }} />
                        </div>
                        <div className="c12-g-l-1"></div>
                      </div>
                    </div>

                    <div className='c12-l-4'>
                      <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                      <select className="small" onChange={toolHandler} style={{ "width": '98%', 'marginTop': '1px','marginLeft': '2px' }} value={selectedTool}>
                        <option value="0" >Select Tools</option>
                        {
                          tools.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.tool_description}</option>
                          )
                        }
                      </select>
                    </div>
                    <div className='c12-l-1'>
                      <p style={{ 'marginTop': '5px' }}>Indent Qty</p>
                      <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={indentQty}
                        placeholder="Indent Qty" />
                    </div>
                    <div className='c12-l-1'>
                      <p style={{ 'marginTop': '5px' }}>Unit</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={uom}
                        placeholder="Unit" />
                    </div>
                    <div className='c12-l-1'>
                      <p style={{ 'marginTop': '5px' }}>Qty Issued</p>
                      <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={qtyIssued}
                        placeholder="Qty Issued" />
                    </div>  
                    <div className='c12-l-1'>
                      <p style={{ 'marginTop': '5px' }}>Avlble Qty</p>
                      <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={avlblQty}
                        placeholder="Avlbl Qty" />
                    </div>                   
                    <div className='c12-l-1'>
                      <p style={{ 'marginTop': '5px' }}>Issue Qty</p>
                      <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={qty}
                        placeholder="Quantity" onChange={qtyHandler} />
                    </div>


                  </div>

                  <div className="row style={{'height':'95'}}">
                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '260px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="8%">Id</th>
                            <th className="th-border left" width="15%">Tool Code</th>
                            <th className="th-border left" width="50%">Tool Description</th>
                            <th className="th-border left" width="15%">Quantity</th>                          
                            <th className="th-border left" width="15%">Unit</th>
                            <th className="th-border" width="8%">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {

                                itemDetails.map((item, index) =>
                                  <tr className="tr-border tr-two-color-blue" key={index}>
                                    <td className="center">{item.id}</td>
                                    <td hidden className="center">{item.tool_name_id}</td>
                                    <td hidden className="">{item.tool_id}</td>
                                    <td className="">{item.tool_code}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="">{item.quantity}</td>                                   
                                    <td className="">{item.uom}</td>
                                    <td onClick={() => { deleteTransferIssue(item.id, item.tool_name_id,item.quantity) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                                    {/*
                                <td onClick={()=>{updateIndDetOperation(item.id)}} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                                
                              */}
                                  </tr>
                                )

                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <LoadingModal show={loading} />

                  <button onClick={addTransaction} type="button" name="button"
                    className="btn gradient large round">Add {trTypeName}</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>
        
        
        {/* Display Store POP */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
        {displayStorePop && (  
        <motion.div 
          key="sliding-container" // Crucial for AnimatePresence to work
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          exit="exit" // Specify the exit animation
          transition={transitionSettings}
          id="newTr" className="cont__PopItems">
          <form className="" action="" method="">
            
            
            <div className="row box gradient corner-round-tlr">
              <div className="c12-l-11">
                <h6 className='txt-subtlewhite'>Inventory : {toolName}</h6><br />
              </div>
              
              <div className="c12-l-1 align-right">
                <p onClick={closeStorePop}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
              </div>
            </div>
            

            <div className="row mt8 px16">
              <div className="c12-l-12">

                <div className="row style={{'height':'95'}}">
                  <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                    <table style={{ 'height': '250px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                      <thead className='thead-grey'>
                        <tr>
                          <th className="th-border left" width="15%">Store Name</th>
                          <th className="th-border left" width="50%">Tool Name</th>
                          <th className="th-border left" width="15%">Quantity</th>                          
                        </tr>
                      </thead>
                      <tbody>
                        {
                            possibleStores.map((item, index) =>
                                <tr className="tr-border tr-two-color-blue" key={index}>
                                  <td className="">{item.store_name}</td>
                                  <td className="">{item.tool_description}</td>
                                  <td className="">{item.quantity}</td>                                   
                                </tr>
                              )
                        }
                      </tbody>
                    </table>
                  </div>
                </div>

                <LoadingModal show={loading} /> 
              </div>
            </div>
          </form>
        </motion.div>
        )}
      </AnimatePresence>  

        <div hidden id='IssueNote'>
          {
            (printFlag === true ?
              (
                <Invoice data={invoiceData2} />  
              )
              : <div>No data</div>)
          }
        </div>

        {/* VIEW (Transaction Details - All Type Transaction) */}
        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayView && ( 
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-3">
                  <h3 className='txt-subtlewhite'>{trTypeName} Details</h3>
                </div>
                <div className="c12-l-8"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeView}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>
              {
                viewDataStatus === true &&
                <>
                  <div className="row mt8 px16">

                    <div className="c12-l-6">
                    
                      <div className="c12-l-12">
                        <div className="row">
                          <div className='c12-l-12'>
                            <div className="row">
                              <div className='c12-l-4'>
                                <p>{trTypeName} Number</p>
                                <p hidden>{trID}</p>
                                <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  defaultValue={viewData.tool_transaction[0].transaction_code} />
                            </div>
                              <div className='c12-l-4'>
                                <p>{trTypeName} Date</p>
                                <input type="date" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  defaultValue={viewData.tool_transaction[0].transaction_date.substring(0, 10)} />
                              </div>
                              <div className='c12-l-4'>
                                <p>Referance Document</p>
                                {
                                  (trTypeName === 'Issue' || trTypeName === 'Transfer' ?
                                    (
                                <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  value={viewData.tool_transaction[0].ref_doc_number} /> 
                                    ):( 
                                <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  value={viewData.tool_transaction[0].ref_doc_number} />
                                    ))
                                  }      
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="c12-l-6">
                      <div className="c12-l-12">

                      {
                        (trTypeName === 'Issue' || trTypeName === 'Transfer' ?
                          (

                        <div className="row">
                        
                          <div className='c12-l-5'>
                            <p>Store From</p>
                            <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              defaultValue={viewData.tool_transaction[0].store_name} />
                          </div>

                          <div className='c12-l-5'>
                            <p>Store to</p>
                            <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              defaultValue={viewData.store_to_name[0].store_to_name} />
                          </div>

                          <div className="c12-l-2 px4">
                            <p>Status</p>
                            <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              defaultValue={viewData.tool_transaction[0].status} />                       
                          </div>

                        </div>
                      ):(
                        <div className="row">
                        
                        <div className='c12-l-8'>
                          <p>Store From</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            defaultValue={viewData.tool_transaction[0].store_name} />
                        </div>

                        <div className="c12-l-4 px4">
                          <p>Status</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            defaultValue={viewData.tool_transaction[0].status} />                       
                        </div>

                      </div>
                      ))
                    }
                      </div>
                    </div>


                    <div className="row mt8">
                      <div className="row style={{'height':'95%'}}">
                        <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                          <table style={{ 'height': '330px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                            <thead className='thead-grey'>
                              <tr>
                                <th hidden className="th-border" width="8%">Id</th>
                                <th className="th-border left" width="10%">Tool Code</th>
                                <th className="th-border left" width="30%">Tool Description</th>
                                <th className="th-border center" width="20%">Category Code</th>
                                <th className="th-border left" width="30%">Category Name</th>
                                <th className="th-border left" width="10%">Quantity</th>
                                <th className="th-border left" width="5%">Unit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                viewData.tool_transaction_items.map((item, index) =>
                                  <tr className="tr-border tr-two-color-blue" key={index}>
                                    <td className="">{item.tool_code}</td>
                                    <td className="">{item.tool_description}</td>
                                    <td className="center">{item.category_code}</td>
                                    <td className="">{item.category_name}</td>
                                    <td className="">{item.quantity}</td>
                                    <td className="">{item.uom}</td>
                                  </tr>
                                )
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="row mt8">
                        <div className='c12-l-3'>
                          {
                            (trTypeName === 'Issue' || trTypeName === 'Transfer' || trTypeName === 'Return'?
                              (
                              <div>
                                <button onClick={() => setOnTransit(trID)} type="button" name="button"
                                  style={{ 'display': displayTransitButton }}
                                  className="btn gradient xl round">Set Status to Ontransit</button>
                              </div>
                              )
                              : <div></div>)
                          }
                        </div>
                        <div className='c12-l-3'>
                          {
                            (trTypeName === 'Issue' ?
                              (
                                <div>
                                <button onClick={MyPrintableComponent} type="button" name="button"
                                  className="btn gradient xl round">Print</button>
                                  <LoadingModal show={loading} />
                                </div>
                              )
                              : <div></div>)
                          }
                        </div>
                        <div className='c12-l-3'></div>
                        <div className='c12-l-3'>
                          <p>Prepared By</p>
                          <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                            defaultValue={viewData.tool_transaction[0].user_name} />
                        </div>
                      </div>

                    </div>

                  </div>
                </>
              }
            </form>
          </motion.div>
          )}
        </AnimatePresence>          

        {/* MODIFY (Transaction Details-Issue & receipt) */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayUpdate && (  
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-6">
                  <h3 className='txt-subtlewhite'>Modify {trTypeName} Quantity</h3>
                </div>
                <div className="c12-l-5"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeUpdate}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>
              {
                viewDataStatus === true &&
                <>
                  <div className="row mt8 px16">

                    <div className="c12-l-6">

                      <div className="c12-l-12">
                        <div className="row">
                          <div className='c12-l-12'>
                            <div className="row">
                              <div className='c12-l-4'>
                                <p>{trTypeName} Number</p>
                                <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  value={viewData.tool_transaction[0].transaction_code} />
                              </div>
                              <div className='c12-l-4'>
                                <p>{trTypeName} Date</p>
                                <input type="date" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  value={viewData.tool_transaction[0].transaction_date.substring(0, 10)} />
                              </div>
                              <div className='c12-l-4'>
                                <p>Reference Document</p>
                                {
                                  (trTypeName === 'Issue' || trTypeName === 'Transfer' ?
                                    (
                                <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  value={viewData.tool_transaction[0].ref_doc_number} /> 
                                    ):( 
                                <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                                  value={viewData.tool_transaction[0].ref_doc_id} />
                                    ))
                                  }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="c12-l-6">

                      <div className="c12-l-12">

                      {
                        (trTypeName === 'Issue' || trTypeName === 'Transfer' ?
                          (

                        <div className="row">                    

                          <div className="c12-l-5 px4">
                            <p>Store From</p>
                            <input type="text" className="box small" style={{ 'marginTop': '1px' }}
                              value={viewData.tool_transaction[0].store_name} />                      
                          </div>

                          <div className="c12-l-5">
                            <p>Store to</p>
                            <input type="text" className="box small" style={{ 'marginTop': '1px' }}
                              value={viewData.store_to_name[0].store_to_name} />                      
                          </div>

                          <div className="c12-l-2 px4">
                            <p>Status</p>
                            <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              value={viewData.tool_transaction[0].status} />
                          </div>
                        </div>
                        ):(
                        <div className="row">
                        
                          <div className='c12-l-8'>
                            <p>Store From</p>
                            <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              defaultValue={viewData.tool_transaction[0].store_name} />
                          </div>

                          <div className="c12-l-4 px4">
                            <p>Status</p>
                            <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              defaultValue={viewData.tool_transaction[0].status} />                       
                          </div>

                      </div>
                      ))
                    }

                      </div>
                    </div>

                    <div className="row mt8">
                      <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                        <table style={{ 'height': '390px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                          <thead className='thead-grey'>
                            <tr>
                              <th className="th-border" width="8%">Id</th>
                              {/*  <th className="th-border left" width="10%">Tool Id</th>  */}
                              <th className="th-border left" width="10%">Tool Code</th>
                              <th className="th-border left" width="30%">Tool Description</th>
                              <th className="th-border left" width="30%">Category Name</th>
                              <th className="th-border left" width="10%">Quantity</th>
                              <th className="th-border left" width="5%">Unit</th>
                              {
                                (modifyTrFlag === true ?
                                  (
                                    <th className="th-border left" width="5%">Edit</th>
                                  )
                                  : <td></td>
                                )}
                              {
                                (deleteTrFlag === true ?
                                  (
                                    <th className="th-border left" width="5%">Delete</th>
                                  )
                                  : <td></td>
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {
                              viewData.tool_transaction_items.map((item, index) =>
                                <tr className="tr-border tr-two-color-blue" key={index}>
                                  <td className="center">{item.id}</td>
                                  {/*  <td className="">{item.tool_id}</td>  */}
                                  <td className="">{item.tool_code}</td>
                                  <td className="">{item.tool_description}</td>
                                  <td className="">{item.category_name}</td>
                                  <td className="">{item.quantity}</td>
                                  <td className="">{item.uom}</td>
                                  {
                                    (modifyTrFlag === true ?
                                      (
                                        <td onClick={() => { updateItemOperation(item.id, viewData.tool_transaction[0].status) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                                      )
                                      : <td></td>
                                    )}
                                  {
                                    (deleteTrFlag === true ?
                                      (
                                        <td onClick={() => { deleteItemOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                                      )
                                      : <td></td>
                                    )}
                                </tr>
                              )
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              }
            </form>
          </motion.div>
          )}
        </AnimatePresence> 

        {/* SCREEN FROM MODIFYING LINE ITEM */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
            {displayUpdateIssueDet && ( 
            <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="updateIssueQty" className="cont__lineitem">
            <form className="" action="" method="">
              <div className="row box grey corner-round-tr">
                <div className="c12-l-8">
                  <h6 className='txt-subtlewhite pt8'>Update {trTypeName} Items</h6>
                </div>
                <div className="c12-l-3"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeUpdateIssueDet}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <br />

                  <p style={{ 'marginTop': '5px' }}>Quantity</p>
                  <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                    placeholder="Quantity" value={updQty} onChange={updqtyHandler} /> <br />

                  <button className="btn gradient round large" type="button" onClick={updateLineItem}>Update Quantity</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>  

        {/* B.SCREEN FROM ADDING NEW receipt   */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayReceipt && (
            <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-2">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-9"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeReceipt}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <div className="row">
                    <div className='c12-l-2 pr2'>
                      <p>{trTypeName} Date</p>
                      <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={trDtHandler} />
                    </div>
                    <div className='c12-l-2 pr2'>
                      <p>{trTypeName} Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New" value={trNo} disabled={true} />
                    </div>
                  
                    <div className='c12-l-2 pr2'>
                      <p>Referance Indent</p>
                      <select className="small" value={selectedIndent} onChange={refHandlerForIssuedIndent} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Reference</option>
                        {
                          (refStatus === true ?
                            (
                              refIndentData.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.indent_number}</option>

                              ))
                            : <option>No Data</option>)
                        }
                      </select>
                    </div>

                    <div className='c12-l-2 pr2'>
                      <p>Referance Issue</p>
                      <select className="small" value={selectedIssuedItem} onChange={refHandlerForReceipt} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Reference</option>
                        {
                          (issuedItemListStatus === true ?
                            (
                              issuedItemsList.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.transaction_code}</option>

                              ))
                            : <option>No Data</option>)
                        }
                      </select>
                    </div>


                    <div className='c12-l-4 pr2'>
                      <p>Select Store</p>
                      <select className="small" value={selectedStoreValue} onChange={storeHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Store</option>
                        {
                          siteStoredata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>
                  </div>
                  {/* <div className='row box border-bottom-dark my8'></div> */}
                  <div className='row mt8'>
                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '340px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="5%">Id</th>
                            <th className="th-border center" width="10%">Tool id</th>
                            <th className="th-border left" width="30%">Tool Name</th>
                            <th className="th-border center" width="10%">Quantity</th>
                            <th className="th-border center" width="5%">UOM</th>
                            <th className="th-border center" width="10%">{trTypeName} Qty</th>

                          </tr>
                        </thead>
                        <tbody>
                          {
                            (issuedItemStatus === true ?
                              (
                                issuedItems.map((item, index) =>
                                  <tr className="tr-border" key={index} >
                                    <td hidden className="">{index}</td>
                                    <td className="center">{item.id}</td>
                                    <td className="center">{item.tool_id}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="center">{item.quantity}</td>
                                    <td className="center">{item.uom}</td>
                                    <td>
                                      <input
                                        type="number"
                                        value={rcvdQty[index]} className="box small" style={{ 'textAlign': 'right' }}
                                        onChange={(e) => handleRcvdQuantityChange(index, e.target.value, item.quantity)}
                                      />
                                    </td>
                                  </tr>
                                ))
                              : <tr><td>No Data</td></tr>)
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <button onClick={addReceivedTransaction} type="button" name="button"
                    className="btn gradient large round">Add {trTypeName}</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence> 
     

        {/* C.SCREEN FROM ADDING NEW TRANSFER  (Modified)*/}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayTransfer && (  
          <motion.div
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" style={{ 'display': displayTransfer }} className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-6">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-5"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={CloseTransfer}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-7">
                  <div className="c12-l-12">
                    <div className="row">
                      <div className='c12-l-12 pr12'>
                        <div className="row">
                          <div className='c12-l-4'>
                            <p>Referance Document</p>
                            <select className="small" onChange={refIndentHandler} style={{ "width": '98%', 'marginTop': '1px' }} value={selectedRefIndent}>
                              <option value="0" >Select Indent</option>

                              {
                                refIndent.map((item, index) =>
                                  <option key={item.indentId} value={item.indentId}>{item.indentCode}</option>
                                )
                              }
                            </select>
                          </div>
                          <div className='c12-l-4'>
                            <p>{trTypeName} Date</p>
                            <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              onChange={trDtHandler} />
                          </div>
                          <div className='c12-l-4'>
                            <p>{trTypeName} Number</p>
                            <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                              placeholder="New" value={trNo} disabled={true} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='c12-l-3 px4'>
                    <p>Select Site-Store From</p>
                    <select className="small" value={selectedStoreValue} onChange={storeHandler} style={{ 'marginTop': '1px' }}>
                      <option value="0" >Select Store From</option>
                      {
                        deptSiteStoredata.map((item, index) =>
                          <option key={item.id} value={item.id}>{item.store_name}</option>
                        )
                      }
                    </select>
                </div>

                {/*
                <div className="c12-l-2">
                  <button onClick={() => getPendingIndent(trStore,trRef)} type="button" name="button"
                  className="btn gradient round" style={{"marginTop":"20px"}}>Show</button>
                </div>
*/}

                <div className="row">
                  <div className='c12-l-3'>
                    <div className="row">
                      <div className="c12-l-10">
                        <p style={{ 'marginTop': '5px' }}>Select Tool Name</p>
                        <select className="small" onChange={getToolsFromIndent} style={{ "width": '98%', 'marginTop': '1px' }} value = {toolNameId}>
                          <option value="0" >Select Tool Name</option>
                          {
                            toolNames.map((item, index) =>
                              <option key={item.id} value={item.id}>{item.tool_name}</option>
                            )
                          }
                        </select>
                      </div>
                      <div className="c12-g-l-1">
                        <img title="Show Inventory" onClick={openStoprePop} src={myImage} alt="Button Icon" style={{ marginTop: '22px', width: '35px', height: '35px', marginRight: '5px' }} />
                      </div>
                      <div className="c12-g-l-1"></div>                      
                    </div>
                  </div>

                  <div className='c12-l-2'>
                    <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                    <select className="small" onChange={toolHandler} style={{ "width": '98%', 'marginTop': '1px' }} value={selectedTool}>
                      <option value="0" >Select Tools</option>
                      {
                        tools.map((item, index) =>
                          <option key={item.id} value={item.id}>{item.tool_description}</option>
                        )
                      }
                    </select>
                  </div>
                  <div className='c12-l-1'>
                    <p style={{ 'marginTop': '5px' }}>Indent Qty</p>
                    <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={indentQty}
                      placeholder="Indent Qty" />
                  </div>
                  <div className='c12-l-1'>
                    <p style={{ 'marginTop': '5px' }}>Unit</p>
                    <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={uom}
                      placeholder="Unit" />
                  </div>
                  <div className='c12-l-1'>
                    <p style={{ 'marginTop': '5px' }}>Qty Issued</p>
                    <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={qtyIssued}
                      placeholder="Qty Issued" />
                  </div>  
                  <div className='c12-l-1'>
                    <p style={{ 'marginTop': '5px' }}>Avlble Qty</p>
                    <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={avlblQty}
                      placeholder="Avlbl Qty" />
                  </div>                   
                  <div className='c12-l-1'>
                    <p style={{ 'marginTop': '5px' }}>Issue Qty</p>
                    <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={qty}
                      placeholder="Quantity" onChange={qtyHandler} />
                  </div>

                  <div className='c12-l-2'>
                    <button onClick={addIssueLineItem} name='qty' type="button" style={{ 'marginTop': '22px', 'width': '90%' }}
                      className="btn gradient round">Add Tools</button>
                  </div>
                </div>


                <div className="row style={{'height':'95%'}}">
                 <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                  <table style={{ 'height': '260px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                    <thead className='thead-grey' style={{'zIndex':'10'}}>
                      <tr>
                        <th className="th-border" width="5%">Id</th>
                        {/*  <th className="th-border center" width="10%">Tool id</th>  */}
                        <th className="th-border center" width="10%">Tool Code</th>
                        <th className="th-border left" width="30%">Tool Name</th>
                        <th className="th-border center" width="10%">Quantity</th>
{/*                        <th className="th-border center" width="10%">Issued Qty</th>
                        <th className="th-border center" width="10%">Available Qty</th>  */}
                        <th className="th-border center" width="5%">Unit</th>
                        {/*  <th className="th-border center" width="5%">Status</th>  
                        <th className="th-border center" width="10%">{trTypeName} Qty</th>  */}
                        <th className="th-border" width="8%">Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        itemDetails.map((item, index) =>
                          <tr className="tr-border tr-two-color-blue" key={index} >
                            <td hidden className="">{index}</td>
                            <td className="center">{item.id}</td>
                            {/*  <td className="center">{item.tool_id}</td>  */}
                            <td hidden className="center">{item.tool_name_id}</td>
                            <td hidden className="">{item.tool_id}</td>
                            <td className="center">{item.tool_code}</td>
                            <td className="">{item.tool_name}</td>
                            <td className="center">{item.quantity}</td>
                            <td className="center">{item.uom}</td>
                            <td onClick={() => { deleteTransferIssue(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
{/*
                            <td className="center">{item.qty_issued}</td>
                            <td className="center">{item.qty_available}</td>
                           
                            {/*  <td className="">{item.status}</td>  */}
                            {/*
                            <td>

                              <input
                                type="number"
                                value={quantities[index]} className="box small" style={{ 'textAlign': 'right', 'z-index': '0' }}
                                onChange={(e) => handleQuantityChange(index, e.target.value, item.qty_issued, item.quantity)}
                              />
                            </td>
                            */}
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                 </div>
              </div>
              <div className='row mt4'>
                <button onClick={addTransaction} type="button" name="button"
                className="btn gradient large round">Add {trTypeName}</button>
            </div>
          </div>

            </form>
          </motion.div>
          )}
        </AnimatePresence>     


        {/* D.SCREEN FROM ADDING NEW Transaction (Return Item)  */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayReturn && (  
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-2">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-9"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeReturn}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <div className="row">
                    <div className='c12-l-2 pr2'>
                      <p>{trTypeName} Date</p>
                      <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={trDtHandler} />
                    </div>
                    <div className='c12-l-2 pr2'>
                      <p>{trTypeName} Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New" value={trNo} disabled={true} />                    
                    </div>
                    <div className='c12-l-4 pr4'>
                      <p>Select Store (Site)</p>
                      <select className="small" value={selectedStoreValue} onChange={storeHandler} style={{ 'marginTop': '1px' }}>
                        <option value="0" >Select Store</option>
                        {
                          siteStoredata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select><br />
                    </div>
                    <div className='c12-l-4 pr2'>
                      <p>Select Store (warehouse)</p>
                      <select className="small" value={selectedWarehouseStoreValue} onChange={warehouseStoreHandler} style={{ 'marginTop': '1px' }}>
                        <option value="0" >Select Store</option>
                        { 
                          warehouseStoredata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>
                  </div>

                  <div className='row'>

                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '330px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="5%">Id</th>
                            <th className="th-border center" width="10%">Tool id</th>
                            <th className="th-border center" width="10%">Tool Code</th>
                            <th className="th-border left" width="30%">Tool Name</th>
                            <th className="th-border center" width="10%">Quantity</th>
                            <th className="th-border center" width="5%">UOM</th>
                            <th className="th-border center" width="10%">{trTypeName} Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            (returnedItemStatus === true ?
                              (
                                returnedItem.map((item, index) =>
                                  <tr className="tr-border" key={index} >
                                    <td hidden className="">{index}</td>
                                    <td className="center">{item.id}</td>
                                    <td className="center">{item.tool_id}</td>
                                    <td className="center">{item.tool_code}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="center">{item.quantity}</td>
                                    <td className="center">{item.uom}</td>
                                    <td>
                                      <input
                                        type="number"
                                        value={quantities[index]} className="box small" style={{ 'textAlign': 'right' }}
                                        onChange={(e) => handleReturnQuantityChange(index, e.target.value, item.quantity)}
                                      />
                                    </td>
                                  </tr>
                                ))
                              : <tr><td>No data</td></tr>)
                          }

                        </tbody>
                      </table>
                    </div>
                  </div>

                  <button onClick={addReturnedTransaction} type="button" name="button"
                    className="btn gradient large round">Add {trTypeName}</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>  

        {/* D2.SCREEN FROM ADDING NEW Return item receipt   */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayReceiptReceipt && ( 
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}         
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-3">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-8"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeReturnReceipt}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <div className="row">
                    <div className='c12-l-2 pr12'>
                      <p>{trTypeName} Date</p>
                      <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={trDtHandler} />
                    </div>
                    <div className='c12-l-2 pr12'>
                      <p>{trTypeName} Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New" value={trNo} disabled={true} />        
                    </div>
                    <div className='c12-l-3 pr12'>
                      <p>Referance Return</p>
                      <select className="small" value={selectedReturnedRef} onChange={refHandlerForReturn} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Reference</option>
                        {
                          (returnedItemListStatus === true ?
                            (
                              returnedItemsList.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.transaction_code}</option>

                              ))
                            : <option>No Data</option>)
                        }
                      </select>  
                    </div>
                    <div className='c12-l-5 pr4'>
                      <p>Select Store</p>
                      <select className="small" value={selectedStoreValue} onChange={storeHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Store</option>
                        {
                          warehouseStoredata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>
                  </div>
                {/*  <div className='row box border-bottom-dark my8'></div> */}
                  <div className='row mt8'>
                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '330px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="5%">Id</th>
                            <th className="th-border center" width="10%">Tool id</th>
                            <th className="th-border left" width="30%">Tool Name</th>
                            <th className="th-border center" width="10%">Quantity</th>
                            <th className="th-border center" width="5%">UOM</th>
                            <th className="th-border center" width="10%">{trTypeName} Qty</th>

                          </tr>
                        </thead>
                        <tbody>
                          {
                            (retItemStatus === true ?
                              (
                                retItems.map((item, index) =>
                                  <tr className="tr-border" key={index} >
                                    <td hidden className="">{index}</td>
                                    <td className="center">{item.id}</td>
                                    <td className="center">{item.tool_id}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="center">{item.quantity}</td>
                                    <td className="center">{item.uom}</td>
                                    <td>
                                      <input
                                        type="number"
                                        value={rcvdRetQty[index]} className="box small" style={{ 'textAlign': 'right' }}
                                        onChange={(e) => handleRcvdRetQuantityChange(index, e.target.value, item.quantity)}
                                      />

                                    </td>

                                  </tr>

                                ))
                              : <tr><td>No Data</td></tr>)
                          }
                        </tbody>
                      </table>

                    </div>
                  </div>
                  <button onClick={addReceivedReturnTransaction} type="button" name="button"
                    className="btn gradient large round">Add {trTypeName}</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>   

        {/* E.SCREEN FROM ADDING NEW PURCHASE   */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayPurchase && (  
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-3">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-8"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closePurchase}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <div className="row">
                    <div className='c12-l-3 pr2'>
                      <p>Reference {trTypeName} No</p>
                      <input type="text" value={poNumber} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="Purchase Number" onChange={(e) => setPONumber(e.target.value)} />
                    </div>
                    <div className='c12-l-2 pr2'>
                      <p>{trTypeName} Date</p>
                      <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={trDtHandler} />
                    </div>
                    <div className='c12-l-2 pr2'>
                      <p>{trTypeName} Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New" value={trNo} disabled={true} />                   
                    </div>
                    <div className='c12-l-5 pr4'>
                      <p>Select Store</p>
                      <select value={selectedStoreValue} className="small" onChange={storeHandler} style={{ "width": '98%', 'marginTop': '1px' }} >
                        <option value="0" >Select Store</option>
                        {
                          siteStoredata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className='c12-l-3'>
                      <p style={{ 'marginTop': '5px' }}>Select Categoty</p>
                      <select className="small" onChange={categoryForPurchaseHandler} style={{ "width": '98%', 'marginTop': '1px' }} value={category}>
                        <option value="0" >Select Catagory</option>
                        {
                          categoryForPurchaseData.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.category_name}</option>
                          )
                        }
                      </select>
                    </div>
                    <div className='c12-l-3'>
                      <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                      <select className="small" onChange={toolCodeHandler} style={{ "width": '98%', 'marginTop': '1px' }}
                       value={toolcode}>
                        <option value="0" >Select Tools</option>
                        {
                          tools.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.tool_description}</option>
                          )
                        }
                      </select>
                    </div>
                    <div className='c12-l-1'>
                      <p style={{ 'marginTop': '5px' }}>Quantity</p>
                      <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={qty}
                        placeholder="Quantity" onChange={qtyHandler} />
                    </div>
                    <div className='c12-l-1'>
                      <p style={{ 'marginTop': '5px' }}>Unit</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={selectedUom}
                        placeholder="Unit" />
                    </div>
                    <div className='c12-l-2'>
                      <p style={{ 'marginTop': '5px' }}>Cost</p>
                      <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={cost}
                        placeholder="Cost" onChange={costHandler} />
                    </div>

                    <div className='c12-l-2'>
                      <button onClick={addLineItem} name='qty' type="button" style={{ 'marginTop': '22px', 'width': '90%' }}
                        className="btn gradient round">Add Tools</button>
                    </div>
                  </div>

                  <div className="row style={{'height':'95%'}}">
                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '280px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="8%">Id</th>
                            <th className="th-border left" width="15%">Tool Code</th>
                            <th className="th-border left" width="40%">Tool Name</th>
                            <th className="th-border left" width="15%">Quantity</th>
                            <th className="th-border left" width="15%">Cost</th>
                            <th className="th-border left" width="15%">Unit</th>
                            <th className="th-border" width="8%">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            (lineitemStatus === true ?
                              (
                                lineitem.map((item, index) =>
                                  <tr className="tr-border" key={index}>
                                    <td className="center">{item.id}</td>
                                    <td hidden className="">{item.tool_id}</td>
                                    <td className="">{item.tool_code}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="">{item.quantity}</td>
                                    <td className="">{item.cost}</td>
                                    <td className="">{item.uom}</td>
                                    <td onClick={() => { deleteItem(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                                    {/*
                                <td onClick={()=>{updateIndDetOperation(item.id)}} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                                
                              */}
                                  </tr>
                                ))
                              : <tr><td>No data</td></tr>)
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <LoadingModal show={loading} />

                  <button onClick={addPurchase} type="button" name="button"
                    className="btn gradient large round">Add {trTypeName}</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>  

        {/* F.SCREEN FROM ADDING NEW REPAIR  */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayRepair && ( 
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-2">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-9"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeRepair}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <div className="row">
                    <div className='c12-l-2 pr2'>
                      <p>{trTypeName} Date</p>
                      <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={trDtHandler} />
                    </div>
                    <div className='c12-l-2 pr2'>
                    <p>{trTypeName} Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New" value={trNo} disabled={true} />                    
                    </div>
                    <div className='c12-l-4 pr4'>                     
                        <p>Select Store</p>
                        <select value={selectedStoreValue} className="small" onChange={storeHandler} style={{ 'marginTop': '1px' }}>
                          <option value="0" >Select Store</option>
                          {
                            storedata.map((item, index) =>
                              <option key={item.id} value={item.id}>{item.store_name}</option>
                            )
                          }
                        </select>
                    </div>
                    <div className='c12-l-4 pr4'>
                      <p>Select Repairing Shop</p>
                      <select value={selectedRepairShop} className="small" onChange={storeHandlerRepairShop} style={{ 'marginTop': '1px' }}>
                        <option value="0" >Select Store</option>
                        {
                          repairShops.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className='c12-l-5'>
                      <p style={{ 'marginTop': '5px' }}>Select Tools</p>
                      <select className="small" onChange={toolCodeHandler} style={{ "width": '98%', 'marginTop': '1px' }} value={toolcode}>
                        <option value="0" >Select Tools</option>
                        {
                          toolsDamaged.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.tool_name}</option>
                          )
                        }
                      </select>
                    </div>
                    <div className='c12-l-4'>
                      <p style={{ 'marginTop': '5px' }}>Quantity</p>
                      <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} value={qty}
                        placeholder="Quantity" onChange={qtyHandler} />
                    </div>

                    <div className='c12-l-3'>
                      <button onClick={addRepairItem} name='qty' type="button" style={{ 'marginTop': '22px', 'width': '90%' }}
                        className="btn gradient round">Add Tools</button>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className="row style={{'height':'95%'}}">
                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '280px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="8%">Id</th>
                            <th className="th-border left" width="15%">Tool Code</th>
                            <th className="th-border left" width="40%">Tool Name</th>
                            <th className="th-border left" width="15%">Quantity</th>
                            <th className="th-border left" width="15%">Unit</th>
                            <th className="th-border" width="8%">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            (repairLineitemStatus === true ?
                              (
                                repairLineitem.map((item, index) =>
                                  <tr className="tr-border" key={index}>
                                    <td className="center">{item.id}</td>
                                    <td hidden className="">{item.tool_id}</td>
                                    <td className="">{item.tool_code}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="">{item.quantity}</td>
                                    <td className="">{item.uom}</td>
                                    <td onClick={() => { deleteItem(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                                    {/*
                          <td onClick={()=>{updateIndDetOperation(item.id)}} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                          
                        */}
                                  </tr>
                                ))
                              : <tr><td>No data</td></tr>)
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <button onClick={addRepairTransaction} type="button" name="button"
                    className="btn gradient large round">Add {trTypeName}</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>  

        {/* G.SCREEN FROM ADDING REPAIRED ITEM RECIPT  */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {displayRepairReceipt && (   
          <motion.div 
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-4">
                  <h3 className='txt-subtlewhite'>Add {trTypeName}</h3><br />
                </div>
                <div className="c12-l-7"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeRepairReceipt}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt8 px16">
                <div className="c12-l-12">

                  <div className="row">
                    <div className='c12-l-2 pr12'>
                      <p>{trTypeName} Date</p>
                      <input type="date" value={selectedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={trDtHandler} />
                    </div>
                    <div className='c12-l-2 pr12'>                    
                      <p>{trTypeName} Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New" value={trNo} disabled={true} />
                    </div>
                    <div className='c12-l-3 pr12'>
                      <p>Referance Documents</p>
                      <select value={selecteRepairdItem} className="small" onChange={refHandlerForRepairedItem} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Reference</option>
                        {
                          (pendItemStatus === true ?
                            (
                              pendingRepairedItems.map((item, index) =>
                                <option key={item.id} value={item.id}>{item.transaction_code}</option>

                              ))
                            : <option>No Data</option>)
                        }
                      </select>           
                    </div>
                    <div className='c12-l-5 pr4'>
                      <p>Select Store</p>
                      <select value={selectedStoreValue} className="small" onChange={storeHandler} style={{ 'marginTop': '1px' }}>
                        <option value="0" >Select Store</option>
                        {
                          storedata.map((item, index) =>
                            <option key={item.id} value={item.id}>{item.store_name}</option>
                          )
                        }
                      </select>
                    </div>
                  </div>
                  {/* <div className='row box border-bottom-dark my8'></div> */}
                  <div className='row mt8'>
                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '330px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="5%">Id</th>
                            <th className="th-border center" width="10%">Tool id</th>
                            <th className="th-border left" width="30%">Tool Name</th>
                            <th className="th-border center" width="10%">Quantity</th>
                            <th className="th-border center" width="5%">UOM</th>
                            <th className="th-border center" width="10%">{trTypeName} Qty</th>

                          </tr>
                        </thead>
                        <tbody>
                          {
                            (repairedItemStatus === true ?
                              (
                                repairedItems.map((item, index) =>
                                  <tr className="tr-border" key={index} >
                                    <td hidden className="">{index}</td>
                                    <td className="center">{item.id}</td>
                                    <td className="center">{item.tool_id}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="center">{item.quantity}</td>
                                    <td className="center">{item.uom}</td>
                                    <td>
                                      <input
                                        type="number"
                                        value={rcvdQty[index]} className="box small" style={{ 'textAlign': 'right' }}
                                        onChange={(e) => handleRepairedQuantityChange(index, e.target.value, item.quantity)}
                                      />

                                    </td>

                                  </tr>

                                ))
                              : <tr><td>No Data</td></tr>)
                          }
                        </tbody>
                      </table>

                    </div>
                  </div>
                  <button onClick={addRepairedItem} type="button" name="button"
                    className="btn gradient xl round">Add {trTypeName}</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>   

        </div>
      </div>
    </div>
  );
}

export default Transaction;
